/**
 * A function to create a log object for the 'shoutoutLpPageView100' event (evid: 100)
 *
 * Event description: shoutout lp -> page view.
 *
 * @param {shoutoutLpPageView100Params} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutLpPageView100Params>} LogObject<shoutoutLpPageView100Params>
 */
export function shoutoutLpPageView100(params) {
    return { evid: 100, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutLpShareButton' event (evid: 101)
 *
 * Event description: shoutout lp -> share button.
 *
 * @param {shoutoutLpShareButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<shoutoutLpShareButtonParams>} LogObject<shoutoutLpShareButtonParams>
 */
export function shoutoutLpShareButton(params) {
    return { evid: 101, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutLpHomeLink' event (evid: 103)
 *
 * Event description: shoutout lp -> home link.
 *
 * @param {shoutoutLpHomeLinkParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutLpHomeLinkParams>} LogObject<shoutoutLpHomeLinkParams>
 */
export function shoutoutLpHomeLink(params) {
    return { evid: 103, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutLpUserSiteLink' event (evid: 104)
 *
 * Event description: shoutout lp -> user site link.
 *
 * @param {shoutoutLpUserSiteLinkParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutLpUserSiteLinkParams>} LogObject<shoutoutLpUserSiteLinkParams>
 */
export function shoutoutLpUserSiteLink(params) {
    return { evid: 104, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsPageView' event (evid: 105)
 *
 * Event description: stats page view
 *
 * @param {shoutoutStatsPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} campain_status - "the status of the campaign optional values: sent/published/sent and published"
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} stats_data - json with all the stats data of the site
 * @property {GUID} message_id - NA
 * @property {string} origin - "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsPageViewParams>} LogObject<shoutoutStatsPageViewParams>
 */
export function shoutoutStatsPageView(params) {
    return { evid: 105, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemEditClick' event (evid: 106)
 *
 * Event description: item edit click on stage
 *
 * @param {shoutoutComposeItemEditClickParams} params - The parameters for this event
 * @property {boolean} is_title - is title region
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - NA
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeItemEditClickParams>} LogObject<shoutoutComposeItemEditClickParams>
 */
export function shoutoutComposeItemEditClick(params) {
    return { evid: 106, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemRemoved' event (evid: 107)
 *
 * Event description: item removed
 *
 * @param {shoutoutComposeItemRemovedParams} params - The parameters for this event
 * @property {boolean} is_title - is title region
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - NA
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeItemRemovedParams>} LogObject<shoutoutComposeItemRemovedParams>
 */
export function shoutoutComposeItemRemoved(params) {
    return { evid: 107, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPreviewAndTestPageView' event (evid: 108)
 *
 * Event description: test and preview
 *
 * @param {shoutoutPreviewAndTestPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - na
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPreviewAndTestPageViewParams>} LogObject<shoutoutPreviewAndTestPageViewParams>
 */
export function shoutoutPreviewAndTestPageView(params) {
    return { evid: 108, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTestSendTestEmail' event (evid: 109)
 *
 * Event description: click on send on the send test popup
 *
 * @param {shoutoutTestSendTestEmailParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} source - NA
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - NA
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutTestSendTestEmailParams>} LogObject<shoutoutTestSendTestEmailParams>
 */
export function shoutoutTestSendTestEmail(params) {
    return { evid: 109, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposePageView' event (evid: 11)
 *
 * Event description: shoutout compose -> page view.
 *
 * @param {shoutoutComposePageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} template_name - template_name
 * @property {string} tags - tags injected in composer
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - source from where the users open the composer
 * @property {string} campaign_source - web/mobile
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<shoutoutComposePageViewParams>} LogObject<shoutoutComposePageViewParams>
 */
export function shoutoutComposePageView(params) {
    return { evid: 11, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarSmartActionsClick' event (evid: 110)
 *
 * Event description: Smart actions click
 *
 * @param {shoutoutSidebarSmartActionsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarSmartActionsClickParams>} LogObject<shoutoutSidebarSmartActionsClickParams>
 */
export function shoutoutSidebarSmartActionsClick(params) {
    return { evid: 110, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'sieWelcomePanelGetStartedClick' event (evid: 111)
 *
 * Event description: when user clicks on the getting started button in the welcome panel
 *
 * @param {sieWelcomePanelGetStartedClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - ts
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - view_mode
 * @property {boolean} shoutout_user - is_shoutout_user
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<sieWelcomePanelGetStartedClickParams>} LogObject<sieWelcomePanelGetStartedClickParams>
 */
export function sieWelcomePanelGetStartedClick(params) {
    return { evid: 111, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'sieEditorPanelReturningBannerView' event (evid: 112)
 *
 * Event description: user viewed banner CTA
 *
 * @param {sieEditorPanelReturningBannerViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - timespan from session start
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - view_mode
 * @property {string} type - generic/store
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<sieEditorPanelReturningBannerViewParams>} LogObject<sieEditorPanelReturningBannerViewParams>
 */
export function sieEditorPanelReturningBannerView(params) {
    return { evid: 112, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'sieEditorPanelReturningBannerClick' event (evid: 113)
 *
 * Event description: user clicked on the banner
 *
 * @param {sieEditorPanelReturningBannerClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - timespan from session start
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - view_mode
 * @property {string} type - generic/store
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<sieEditorPanelReturningBannerClickParams>} LogObject<sieEditorPanelReturningBannerClickParams>
 */
export function sieEditorPanelReturningBannerClick(params) {
    return { evid: 113, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'tipsLightboxViewed' event (evid: 116)
 *
 * Event description: event is triggered when the lightbox opened in shoutout contacts page, giving qty limitation for the number of contacts.
 *
 * @param {tipsLightboxViewedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_wix_premium - is_wix_premium
 * @property {string} package_id - package_name
 * @property {number} number_of_contacts - number_of_contacts the user tried to send to
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {boolean} is_shoutout_premium - is_shoutout_premium
 * @return {LogObject<tipsLightboxViewedParams>} LogObject<tipsLightboxViewedParams>
 */
export function tipsLightboxViewed(params) {
    return { evid: 116, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'tipsLightboxCtaClick' event (evid: 117)
 *
 * Event description: event is triggered when the user is clicking on "confirm" in the lightbox in shoutout contacts page, giving qty limitation for the number of contacts.
 *
 * @param {tipsLightboxCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<tipsLightboxCtaClickParams>} LogObject<tipsLightboxCtaClickParams>
 */
export function tipsLightboxCtaClick(params) {
    return { evid: 117, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'tipsLightboxCancelClick' event (evid: 118)
 *
 * Event description: event is triggered when the user is clicking on "cancel" in the lightbox in shoutout contacts page, giving qty limitation for the number of contacts.
 *
 * @param {tipsLightboxCancelClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<tipsLightboxCancelClickParams>} LogObject<tipsLightboxCancelClickParams>
 */
export function tipsLightboxCancelClick(params) {
    return { evid: 118, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'captchaView' event (evid: 119)
 *
 * Event description: captcha view - when user send a SO message (test or real SO) captcha is display  in order to prevent bots from sending mails
 *
 * @param {captchaViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - send page/ test mail.  did the  user click on the test, or on the send shoutout button
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<captchaViewParams>} LogObject<captchaViewParams>
 */
export function captchaView(params) {
    return { evid: 119, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemAddClick' event (evid: 12)
 *
 * Event description: shoutout compose -> item add click.
 *
 * @param {shoutoutComposeItemAddClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subtype - subtype for region type
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} adding_method - click / drag
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @property {GUID} message_id - message_id
 * @return {LogObject<shoutoutComposeItemAddClickParams>} LogObject<shoutoutComposeItemAddClickParams>
 */
export function shoutoutComposeItemAddClick(params) {
    return { evid: 12, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutout123StepsHeaderDashboardClick' event (evid: 120)
 *
 * Event description: in the shoutout 1-2-3 steps page header  click on the "dashboard"
 *
 * @param {shoutout123StepsHeaderDashboardClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutout123StepsHeaderDashboardClickParams>} LogObject<shoutout123StepsHeaderDashboardClickParams>
 */
export function shoutout123StepsHeaderDashboardClick(params) {
    return { evid: 120, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutout123StepsHeaderLogoClick' event (evid: 121)
 *
 * Event description: in the shoutout  1-2-3 steps page header - click on the shoutout logo
 *
 * @param {shoutout123StepsHeaderLogoClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutout123StepsHeaderLogoClickParams>} LogObject<shoutout123StepsHeaderLogoClickParams>
 */
export function shoutout123StepsHeaderLogoClick(params) {
    return { evid: 121, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutout123StepsHeaderWizardClick' event (evid: 122)
 *
 * Event description: in the shoutout 1-2-3 steps page header - click/moving between steps in 1-2-3
 *
 * @param {shoutout123StepsHeaderWizardClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} step - which step
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutout123StepsHeaderWizardClickParams>} LogObject<shoutout123StepsHeaderWizardClickParams>
 */
export function shoutout123StepsHeaderWizardClick(params) {
    return { evid: 122, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutChooseContactsImportClick' event (evid: 123)
 *
 * Event description: in shoutout contacts (step 2) click on "import contacts"
 *
 * @param {shoutoutChooseContactsImportClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} total_contacts - total number of contacts in list
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutChooseContactsImportClickParams>} LogObject<shoutoutChooseContactsImportClickParams>
 */
export function shoutoutChooseContactsImportClick(params) {
    return { evid: 123, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutChooseContactsManageClick' event (evid: 124)
 *
 * Event description: in shoutout contacts (step 2) click on "manage contacts"
 *
 * @param {shoutoutChooseContactsManageClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutChooseContactsManageClickParams>} LogObject<shoutoutChooseContactsManageClickParams>
 */
export function shoutoutChooseContactsManageClick(params) {
    return { evid: 124, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardWidgetItemClick' event (evid: 125)
 *
 * Event description: in the shoutout dashboard (dashboard in the side bar) click on any widget
 *
 * @param {shoutoutDashboardWidgetItemClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - widget  name
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} message_type - published, draft, schedule, etc...
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} campaign_source - web/mobile
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} value - action value
 * @return {LogObject<shoutoutDashboardWidgetItemClickParams>} LogObject<shoutoutDashboardWidgetItemClickParams>
 */
export function shoutoutDashboardWidgetItemClick(params) {
    return { evid: 125, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutDeleteClick' event (evid: 126)
 *
 * Event description: in my shoutout , on one of the SO items click on delete to open delete dialog
 *
 * @param {shoutoutMyShoutoutDeleteClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} messages_type - draft/published
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutDeleteClickParams>} LogObject<shoutoutMyShoutoutDeleteClickParams>
 */
export function shoutoutMyShoutoutDeleteClick(params) {
    return { evid: 126, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutDeleteDialogDeleteClick' event (evid: 127)
 *
 * Event description: in my shoutout , on one of the SO items, in the delete dialog click on "delete"
 *
 * @param {shoutoutMyShoutoutDeleteDialogDeleteClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutDeleteDialogDeleteClickParams>} LogObject<shoutoutMyShoutoutDeleteDialogDeleteClickParams>
 */
export function shoutoutMyShoutoutDeleteDialogDeleteClick(params) {
    return { evid: 127, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutDeleteDialogView' event (evid: 128)
 *
 * Event description: in my shoutout , on one of the SO items after click on delete - the "delete dialog" opens
 *
 * @param {shoutoutMyShoutoutDeleteDialogViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} messages_type - draft/published
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutDeleteDialogViewParams>} LogObject<shoutoutMyShoutoutDeleteDialogViewParams>
 */
export function shoutoutMyShoutoutDeleteDialogView(params) {
    return { evid: 128, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutDuplicateMessageClick' event (evid: 129)
 *
 * Event description: in my shoutout , on one of the SO items click on "duplicate message"
 *
 * @param {shoutoutMyShoutoutDuplicateMessageClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} messages_type - draft/published
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutDuplicateMessageClickParams>} LogObject<shoutoutMyShoutoutDuplicateMessageClickParams>
 */
export function shoutoutMyShoutoutDuplicateMessageClick(params) {
    return { evid: 129, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemReady' event (evid: 13)
 *
 * Event description: shoutout compose -> item ready.
 *
 * @param {shoutoutComposeItemReadyParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subtype - subtype of the region type
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeItemReadyParams>} LogObject<shoutoutComposeItemReadyParams>
 */
export function shoutoutComposeItemReady(params) {
    return { evid: 13, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardPageView' event (evid: 130)
 *
 * Event description: event fired when opening the shoutout dashboard view , from any origin in the app
 *
 * @param {shoutoutDashboardPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} templatesList - templates list loaded to user - for  impressions
 * @property {number} load_time - milisecond
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardPageViewParams>} LogObject<shoutoutDashboardPageViewParams>
 */
export function shoutoutDashboardPageView(params) {
    return { evid: 130, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutFilterSelect' event (evid: 131)
 *
 * Event description: in my shoutout select one of the filters (tabs) : published, drafts and etc
 *
 * @param {shoutoutMyShoutoutFilterSelectParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} filter_type - all, published, drafts, archived
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutFilterSelectParams>} LogObject<shoutoutMyShoutoutFilterSelectParams>
 */
export function shoutoutMyShoutoutFilterSelect(params) {
    return { evid: 131, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutMoveToActive' event (evid: 132)
 *
 * Event description: in my shoutout , on one of the archived items click on "move to active"
 *
 * @param {shoutoutMyShoutoutMoveToActiveParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutMoveToActiveParams>} LogObject<shoutoutMyShoutoutMoveToActiveParams>
 */
export function shoutoutMyShoutoutMoveToActive(params) {
    return { evid: 132, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutMoveToArchive' event (evid: 133)
 *
 * Event description: in my shoutout , on one of the SO items click on "move to archive"
 *
 * @param {shoutoutMyShoutoutMoveToArchiveParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutMoveToArchiveParams>} LogObject<shoutoutMyShoutoutMoveToArchiveParams>
 */
export function shoutoutMyShoutoutMoveToArchive(params) {
    return { evid: 133, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutShareClick' event (evid: 134)
 *
 * Event description: in my shoutout, on one of the SO items click on one of the share options
 *
 * @param {shoutoutMyShoutoutShareClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {GUID} msid - msid
 * @property {string} value - selected share option
 * @return {LogObject<shoutoutMyShoutoutShareClickParams>} LogObject<shoutoutMyShoutoutShareClickParams>
 */
export function shoutoutMyShoutoutShareClick(params) {
    return { evid: 134, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutStatsClick' event (evid: 135)
 *
 * Event description: in my shoutout, on one of the SO items click on "stats" to open statistical page
 *
 * @param {shoutoutMyShoutoutStatsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard, my campaigns
 * @property {string} package_group - package_group
 * @property {string} message_type - the label of the post (published, scheduled, etc...)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} campaign_source - web/mobile
 * @property {GUID} message_id - message id
 * @property {string} origin - icon, card, toast
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutStatsClickParams>} LogObject<shoutoutMyShoutoutStatsClickParams>
 */
export function shoutoutMyShoutoutStatsClick(params) {
    return { evid: 135, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPreviewPageBackToEditingClick' event (evid: 136)
 *
 * Event description: in the shoutout preview page click on "back to editing" button
 *
 * @param {shoutoutPreviewPageBackToEditingClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPreviewPageBackToEditingClickParams>} LogObject<shoutoutPreviewPageBackToEditingClickParams>
 */
export function shoutoutPreviewPageBackToEditingClick(params) {
    return { evid: 136, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPreviewPageTestMailClick' event (evid: 137)
 *
 * Event description: in the shoutout preview page click on "send test mail" button
 *
 * @param {shoutoutPreviewPageTestMailClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPreviewPageTestMailClickParams>} LogObject<shoutoutPreviewPageTestMailClickParams>
 */
export function shoutoutPreviewPageTestMailClick(params) {
    return { evid: 137, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageSubjectNotificationTipView' event (evid: 138)
 *
 * Event description: when editing the subject , and a notification box opens
 *
 * @param {shoutoutSendPageSubjectNotificationTipViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} subject - subject
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} errorCode - error_code
 * @property {GUID} msid - msid
 * @property {string} error_name - string format for error code
 * @return {LogObject<shoutoutSendPageSubjectNotificationTipViewParams>} LogObject<shoutoutSendPageSubjectNotificationTipViewParams>
 */
export function shoutoutSendPageSubjectNotificationTipView(params) {
    return { evid: 138, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposePanelClick' event (evid: 139)
 *
 * Event description: in the in the shoutout compose page click on the side menu
 *
 * @param {shoutoutComposePanelClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - panel chosen value
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposePanelClickParams>} LogObject<shoutoutComposePanelClickParams>
 */
export function shoutoutComposePanelClick(params) {
    return { evid: 139, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeStyleSelected' event (evid: 14)
 *
 * Event description: shoutout compose -> style selected.
 *
 * @param {shoutoutComposeStyleSelectedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<shoutoutComposeStyleSelectedParams>} LogObject<shoutoutComposeStyleSelectedParams>
 */
export function shoutoutComposeStyleSelected(params) {
    return { evid: 14, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposePreviewClick' event (evid: 140)
 *
 * Event description: in the in the shoutout compose page click on "preview & test"
 *
 * @param {shoutoutComposePreviewClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposePreviewClickParams>} LogObject<shoutoutComposePreviewClickParams>
 */
export function shoutoutComposePreviewClick(params) {
    return { evid: 140, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmDialogCloseClick' event (evid: 141)
 *
 * Event description: close returning-user tips dialog,
 * returning user dialog view opens when user returning first time and open  composer
 * ssm - shoutout styling model
 *
 * @param {shoutoutComposeReturningUserSsmDialogCloseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmDialogCloseClickParams>} LogObject<shoutoutComposeReturningUserSsmDialogCloseClickParams>
 */
export function shoutoutComposeReturningUserSsmDialogCloseClick(params) {
    return { evid: 141, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmDialogShowClick' event (evid: 142)
 *
 * Event description: Clicking 'show' on returning-user tips dialog
 * returning user dialog view opens when user returning first time and open composer
 * ssm - shoutout styling model
 *
 * @param {shoutoutComposeReturningUserSsmDialogShowClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmDialogShowClickParams>} LogObject<shoutoutComposeReturningUserSsmDialogShowClickParams>
 */
export function shoutoutComposeReturningUserSsmDialogShowClick(params) {
    return { evid: 142, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmDialogView' event (evid: 143)
 *
 * Event description: Showing the returning-user tips dialog
 * returning user dialog view opens when user returning first time and open  composer
 * ssm - shoutout styling model
 *
 * @param {shoutoutComposeReturningUserSsmDialogViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmDialogViewParams>} LogObject<shoutoutComposeReturningUserSsmDialogViewParams>
 */
export function shoutoutComposeReturningUserSsmDialogView(params) {
    return { evid: 143, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmTipNextClick' event (evid: 144)
 *
 * Event description: Clicking Next on tip (from the tips dialog)
 * returning user tip view opens when user returning first time and open  composer, dialog opens and clicking on "show"
 *
 * @param {shoutoutComposeReturningUserSsmTipNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} current - current
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmTipNextClickParams>} LogObject<shoutoutComposeReturningUserSsmTipNextClickParams>
 */
export function shoutoutComposeReturningUserSsmTipNextClick(params) {
    return { evid: 144, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmTipSkipClick' event (evid: 145)
 *
 * Event description: closing tips  from the tips dialog
 * returning user tip view opens when user returning first time and open composer, dialog opens and clicking on "show"
 *
 * @param {shoutoutComposeReturningUserSsmTipSkipClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} current - current
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmTipSkipClickParams>} LogObject<shoutoutComposeReturningUserSsmTipSkipClickParams>
 */
export function shoutoutComposeReturningUserSsmTipSkipClick(params) {
    return { evid: 145, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeReturningUserSsmTipView' event (evid: 146)
 *
 * Event description: Viewing tips  from the tips dialog
 * returning user tip view opens when user returning first time and open  composer, dialog opens and clicking on "show"
 *
 * @param {shoutoutComposeReturningUserSsmTipViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} current - current
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeReturningUserSsmTipViewParams>} LogObject<shoutoutComposeReturningUserSsmTipViewParams>
 */
export function shoutoutComposeReturningUserSsmTipView(params) {
    return { evid: 146, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeFirstTimeUserDialogVideoView' event (evid: 147)
 *
 * Event description: Viewing welcome video lightbox (new user)
 *
 * @param {shoutoutComposeFirstTimeUserDialogVideoViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeFirstTimeUserDialogVideoViewParams>} LogObject<shoutoutComposeFirstTimeUserDialogVideoViewParams>
 */
export function shoutoutComposeFirstTimeUserDialogVideoView(params) {
    return { evid: 147, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarDashboardClick' event (evid: 148)
 *
 * Event description: click on the dashboard button
 *
 * @param {shoutoutSidebarDashboardClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarDashboardClickParams>} LogObject<shoutoutSidebarDashboardClickParams>
 */
export function shoutoutSidebarDashboardClick(params) {
    return { evid: 148, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarHelpClick' event (evid: 149)
 *
 * Event description: click on help icon
 *
 * @param {shoutoutSidebarHelpClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarHelpClickParams>} LogObject<shoutoutSidebarHelpClickParams>
 */
export function shoutoutSidebarHelpClick(params) {
    return { evid: 149, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeNextPage' event (evid: 15)
 *
 * Event description: shoutout compose -> next page.
 *
 * @param {shoutoutComposeNextPageParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} template_name - template name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeNextPageParams>} LogObject<shoutoutComposeNextPageParams>
 */
export function shoutoutComposeNextPage(params) {
    return { evid: 15, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarMyShoutoutClick' event (evid: 150)
 *
 * Event description: click on my shoutout button
 *
 * @param {shoutoutSidebarMyShoutoutClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarMyShoutoutClickParams>} LogObject<shoutoutSidebarMyShoutoutClickParams>
 */
export function shoutoutSidebarMyShoutoutClick(params) {
    return { evid: 150, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarResourcesClick' event (evid: 151)
 *
 * Event description: click on resources   button
 *
 * @param {shoutoutSidebarResourcesClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarResourcesClickParams>} LogObject<shoutoutSidebarResourcesClickParams>
 */
export function shoutoutSidebarResourcesClick(params) {
    return { evid: 151, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEmailVerificationCodeNotCorrect' event (evid: 152)
 *
 * Event description: Entering wrong confirmation code, click confirm and get warning message
 *
 * @param {shoutoutEmailVerificationCodeNotCorrectParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEmailVerificationCodeNotCorrectParams>} LogObject<shoutoutEmailVerificationCodeNotCorrectParams>
 */
export function shoutoutEmailVerificationCodeNotCorrect(params) {
    return { evid: 152, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEmailVerificationClickConfirmSendCode' event (evid: 153)
 *
 * Event description: Sending confirmation code - clicking on confirm in lightbox - to confirm the system to send the confirmation code
 *
 * @param {shoutoutEmailVerificationClickConfirmSendCodeParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} resend - resend
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEmailVerificationClickConfirmSendCodeParams>} LogObject<shoutoutEmailVerificationClickConfirmSendCodeParams>
 */
export function shoutoutEmailVerificationClickConfirmSendCode(params) {
    return { evid: 153, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEmailVerificationExplanationExit' event (evid: 154)
 *
 * Event description: click to Exiting verification lightbox
 *
 * @param {shoutoutEmailVerificationExplanationExitParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEmailVerificationExplanationExitParams>} LogObject<shoutoutEmailVerificationExplanationExitParams>
 */
export function shoutoutEmailVerificationExplanationExit(params) {
    return { evid: 154, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEmailVerificationExplanationView' event (evid: 155)
 *
 * Event description: Showing email verification lightbox after user click on send button
 *
 * @param {shoutoutEmailVerificationExplanationViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEmailVerificationExplanationViewParams>} LogObject<shoutoutEmailVerificationExplanationViewParams>
 */
export function shoutoutEmailVerificationExplanationView(params) {
    return { evid: 155, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEmailVerificationSuccessView' event (evid: 156)
 *
 * Event description: Verification successful view open after click confirm with  correct code
 *
 * @param {shoutoutEmailVerificationSuccessViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEmailVerificationSuccessViewParams>} LogObject<shoutoutEmailVerificationSuccessViewParams>
 */
export function shoutoutEmailVerificationSuccessView(params) {
    return { evid: 156, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageDmarcDialogBuyMailboxClick' event (evid: 157)
 *
 * Event description: Clicking on Mailbox purchase on DMARC warning lightbox (enter a Yahoo email)
 *
 * @param {shoutoutSendPageDmarcDialogBuyMailboxClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageDmarcDialogBuyMailboxClickParams>} LogObject<shoutoutSendPageDmarcDialogBuyMailboxClickParams>
 */
export function shoutoutSendPageDmarcDialogBuyMailboxClick(params) {
    return { evid: 157, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageDmarcDialogCloseClick' event (evid: 158)
 *
 * Event description: Closing DMARC warning lightbox (enter a Yahoo email)
 *
 * @param {shoutoutSendPageDmarcDialogCloseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageDmarcDialogCloseClickParams>} LogObject<shoutoutSendPageDmarcDialogCloseClickParams>
 */
export function shoutoutSendPageDmarcDialogCloseClick(params) {
    return { evid: 158, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageDmarcDialogView' event (evid: 159)
 *
 * Event description: Showing DMARC warning lightbox (enter a Yahoo email)
 *
 * @param {shoutoutSendPageDmarcDialogViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageDmarcDialogViewParams>} LogObject<shoutoutSendPageDmarcDialogViewParams>
 */
export function shoutoutSendPageDmarcDialogView(params) {
    return { evid: 159, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsDownloadCta' event (evid: 16)
 *
 * Event description: when the user clicks on "download" in email recipients screen
 *
 * @param {shoutoutStatsDownloadCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} filter_name - filter_name
 * @property {number} contact_count - contact count in the list being downloaded
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsDownloadCtaParams>} LogObject<shoutoutStatsDownloadCtaParams>
 */
export function shoutoutStatsDownloadCta(params) {
    return { evid: 16, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageDmarcDialogWarningClick' event (evid: 160)
 *
 * Event description: Clicking on DMARC warning link (enter a Yahoo email)
 *
 * @param {shoutoutSendPageDmarcDialogWarningClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageDmarcDialogWarningClickParams>} LogObject<shoutoutSendPageDmarcDialogWarningClickParams>
 */
export function shoutoutSendPageDmarcDialogWarningClick(params) {
    return { evid: 160, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageEmailValidationView' event (evid: 161)
 *
 * Event description: Checking email validation
 *
 * @param {shoutoutSendPageEmailValidationViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} result - result
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} raw_result - raw result of validation
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageEmailValidationViewParams>} LogObject<shoutoutSendPageEmailValidationViewParams>
 */
export function shoutoutSendPageEmailValidationView(params) {
    return { evid: 161, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageSendTestEmailClick' event (evid: 162)
 *
 * Event description: Clicking on Test Email button
 *
 * @param {shoutoutSendPageSendTestEmailClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageSendTestEmailClickParams>} LogObject<shoutoutSendPageSendTestEmailClickParams>
 */
export function shoutoutSendPageSendTestEmailClick(params) {
    return { evid: 162, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutCompleteDialogDoneClick' event (evid: 163)
 *
 * Event description: Clicking on Done in completion dialog
 *
 * @param {shoutoutCompleteDialogDoneClickParams} params - The parameters for this event
 * @property {string} action_complete - publish/ send or schedule
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutCompleteDialogDoneClickParams>} LogObject<shoutoutCompleteDialogDoneClickParams>
 */
export function shoutoutCompleteDialogDoneClick(params) {
    return { evid: 163, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWebPageLandingSubscriptionClick' event (evid: 164)
 *
 * Event description: on the shoutout web page that UoU gets, he clicks on subscription button
 *
 * @param {shoutoutWebPageLandingSubscriptionClickParams} params - The parameters for this event
 * @property {string} pageId - message identifier
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} email - email
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} page_id - message identifier
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutWebPageLandingSubscriptionClickParams>} LogObject<shoutoutWebPageLandingSubscriptionClickParams>
 */
export function shoutoutWebPageLandingSubscriptionClick(params) {
    return { evid: 164, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostSetUpPageView' event (evid: 165)
 *
 * Event description: facebook boost page view
 *
 * @param {fbBoostSetUpPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - origin to view
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostSetUpPageViewParams>} LogObject<fbBoostSetUpPageViewParams>
 */
export function fbBoostSetUpPageView(params) {
    return { evid: 165, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutCompleteDialogDoneView' event (evid: 166)
 *
 * Event description: Viewing completion dialog
 *
 * @param {shoutoutCompleteDialogDoneViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutCompleteDialogDoneViewParams>} LogObject<shoutoutCompleteDialogDoneViewParams>
 */
export function shoutoutCompleteDialogDoneView(params) {
    return { evid: 166, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutBannedView' event (evid: 167)
 *
 * Event description: user get suspended account view when entering shoutout
 *
 * @param {shoutoutBannedViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutBannedViewParams>} LogObject<shoutoutBannedViewParams>
 */
export function shoutoutBannedView(params) {
    return { evid: 167, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutBannedResolveClick' event (evid: 168)
 *
 * Event description: when user get suspended account view when entering shoutout and click on the "resolve" button - take him to ticket system...
 *
 * @param {shoutoutBannedResolveClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutBannedResolveClickParams>} LogObject<shoutoutBannedResolveClickParams>
 */
export function shoutoutBannedResolveClick(params) {
    return { evid: 168, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'sosaDialogChoose' event (evid: 169)
 *
 * Event description: Choosing value in the existing Wix users dialog
 *
 * @param {sosaDialogChooseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} selection - selected path
 * @property {GUID} msid - msid
 * @return {LogObject<sosaDialogChooseParams>} LogObject<sosaDialogChooseParams>
 */
export function sosaDialogChoose(params) {
    return { evid: 169, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutFirstTimeClose' event (evid: 17)
 *
 * Event description: shoutout -> first time close.
 *
 * @param {shoutoutFirstTimeCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutFirstTimeCloseParams>} LogObject<shoutoutFirstTimeCloseParams>
 */
export function shoutoutFirstTimeClose(params) {
    return { evid: 17, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsShareClick' event (evid: 170)
 *
 * Event description: Clicking on Share icon and choosing platform in a stats page view
 *
 * @param {shoutoutStatsShareClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} origin - "the origin for the share click optional values: share modal/social stats tab"
 * @property {GUID} msid - msid
 * @property {string} value - share value
 * @return {LogObject<shoutoutStatsShareClickParams>} LogObject<shoutoutStatsShareClickParams>
 */
export function shoutoutStatsShareClick(params) {
    return { evid: 170, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutotAdLinkClick' event (evid: 171)
 *
 * Event description: when a UoU clicked on landing page ad
 *
 * @param {shoutotAdLinkClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} page_id - message identifier
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<shoutotAdLinkClickParams>} LogObject<shoutotAdLinkClickParams>
 */
export function shoutotAdLinkClick(params) {
    return { evid: 171, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutOpenInitiated' event (evid: 172)
 *
 * Event description: Event for the first call that the app was served (first is alive), (html loaded)
 *
 * @param {shoutoutOpenInitiatedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutOpenInitiatedParams>} LogObject<shoutoutOpenInitiatedParams>
 */
export function shoutoutOpenInitiated(params) {
    return { evid: 172, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutOnboardingCloseClick' event (evid: 173)
 *
 * Event description: click on close
 * when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another)
 *
 * @param {shoutoutOnboardingCloseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutOnboardingCloseClickParams>} LogObject<shoutoutOnboardingCloseClickParams>
 */
export function shoutoutOnboardingCloseClick(params) {
    return { evid: 173, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutOnboardingNextClick' event (evid: 174)
 *
 * Event description: click on next
 * when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another)
 *
 * @param {shoutoutOnboardingNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} current_step - current step in onboarding flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutOnboardingNextClickParams>} LogObject<shoutoutOnboardingNextClickParams>
 */
export function shoutoutOnboardingNextClick(params) {
    return { evid: 174, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutOnboardingView' event (evid: 175)
 *
 * Event description: view
 * when user goes on the onboarding flow. Onboarding is for new users (4 GIFS, one after another)
 *
 * @param {shoutoutOnboardingViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} current_step - current step in onboarding  flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutOnboardingViewParams>} LogObject<shoutoutOnboardingViewParams>
 */
export function shoutoutOnboardingView(params) {
    return { evid: 175, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutError' event (evid: 176)
 *
 * Event description: general shoutout error
 *
 * @param {shoutoutErrorParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} errorCode - errorCode
 * @property {string} error - error description
 * @property {GUID} msid - msid
 * @property {string} origin - origin of the error
 * @property {string} message_id - message_id
 * @property {string} conversation_id - ai conversation id
 * @return {LogObject<shoutoutErrorParams>} LogObject<shoutoutErrorParams>
 */
export function shoutoutError(params) {
    return { evid: 176, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostSetUpProfilePermissionClick' event (evid: 177)
 *
 * Event description: click on grant profile permission
 *
 * @param {fbBoostSetUpProfilePermissionClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostSetUpProfilePermissionClickParams>} LogObject<fbBoostSetUpProfilePermissionClickParams>
 */
export function fbBoostSetUpProfilePermissionClick(params) {
    return { evid: 177, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostSetUpPagePermissionClick' event (evid: 178)
 *
 * Event description: click on grant page permission
 *
 * @param {fbBoostSetUpPagePermissionClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostSetUpPagePermissionClickParams>} LogObject<fbBoostSetUpPagePermissionClickParams>
 */
export function fbBoostSetUpPagePermissionClick(params) {
    return { evid: 178, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostSetUpSelectPageClick' event (evid: 179)
 *
 * Event description: selecting facebook page
 *
 * @param {fbBoostSetUpSelectPageClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostSetUpSelectPageClickParams>} LogObject<fbBoostSetUpSelectPageClickParams>
 */
export function fbBoostSetUpSelectPageClick(params) {
    return { evid: 179, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPackagePickerRadioButton' event (evid: 18)
 *
 * Event description: Shoutout package picker -> radio button.
 *
 * @param {shoutoutPackagePickerRadioButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPackagePickerRadioButtonParams>} LogObject<shoutoutPackagePickerRadioButtonParams>
 */
export function shoutoutPackagePickerRadioButton(params) {
    return { evid: 18, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostSetUpNextClickClick' event (evid: 180)
 *
 * Event description: clicking on next button
 *
 * @param {fbBoostSetUpNextClickClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostSetUpNextClickClickParams>} LogObject<fbBoostSetUpNextClickClickParams>
 */
export function fbBoostSetUpNextClickClick(params) {
    return { evid: 180, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPreviewAdPageView' event (evid: 181)
 *
 * Event description: ad page view
 *
 * @param {fbBoostPreviewAdPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPreviewAdPageViewParams>} LogObject<fbBoostPreviewAdPageViewParams>
 */
export function fbBoostPreviewAdPageView(params) {
    return { evid: 181, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPreviewAdChangeImageClick' event (evid: 182)
 *
 * Event description: clicking on change image button
 *
 * @param {fbBoostPreviewAdChangeImageClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPreviewAdChangeImageClickParams>} LogObject<fbBoostPreviewAdChangeImageClickParams>
 */
export function fbBoostPreviewAdChangeImageClick(params) {
    return { evid: 182, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPreviewPreviewNextClick' event (evid: 183)
 *
 * Event description: clicking on next button
 *
 * @param {fbBoostPreviewPreviewNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPreviewPreviewNextClickParams>} LogObject<fbBoostPreviewPreviewNextClickParams>
 */
export function fbBoostPreviewPreviewNextClick(params) {
    return { evid: 183, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostBudgetPageView' event (evid: 184)
 *
 * Event description: page view
 *
 * @param {fbBoostBudgetPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostBudgetPageViewParams>} LogObject<fbBoostBudgetPageViewParams>
 */
export function fbBoostBudgetPageView(params) {
    return { evid: 184, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostBudgetChangeBudgetClick' event (evid: 185)
 *
 * Event description: changing budget amount
 *
 * @param {fbBoostBudgetChangeBudgetClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - increase / decease amount
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostBudgetChangeBudgetClickParams>} LogObject<fbBoostBudgetChangeBudgetClickParams>
 */
export function fbBoostBudgetChangeBudgetClick(params) {
    return { evid: 185, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostBudgetEditAgeClick' event (evid: 186)
 *
 * Event description: changing targeted age group
 *
 * @param {fbBoostBudgetEditAgeClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostBudgetEditAgeClickParams>} LogObject<fbBoostBudgetEditAgeClickParams>
 */
export function fbBoostBudgetEditAgeClick(params) {
    return { evid: 186, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostBudgetEditGenderClick' event (evid: 187)
 *
 * Event description: changing targeted gender
 *
 * @param {fbBoostBudgetEditGenderClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostBudgetEditGenderClickParams>} LogObject<fbBoostBudgetEditGenderClickParams>
 */
export function fbBoostBudgetEditGenderClick(params) {
    return { evid: 187, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostBudgetNextClick' event (evid: 188)
 *
 * Event description: clicking on next button
 *
 * @param {fbBoostBudgetNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostBudgetNextClickParams>} LogObject<fbBoostBudgetNextClickParams>
 */
export function fbBoostBudgetNextClick(params) {
    return { evid: 188, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPaymentPageView' event (evid: 189)
 *
 * Event description: page view
 *
 * @param {fbBoostPaymentPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {number} reachByBudgetMax - reach_by_budgetmin
 * @property {number} reachMax - reachMax
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} cpm - cpm
 * @property {number} reachByBudgetMin - reachByBudgetMin
 * @property {string} adAccountId - adAccountId
 * @property {boolean} optimizeForClicks - optimize_for_clicks
 * @property {boolean} customAudienceIncluded - customAudienceIncluded
 * @property {number} budget - budget
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @property {number} cpa - cpa
 * @return {LogObject<fbBoostPaymentPageViewParams>} LogObject<fbBoostPaymentPageViewParams>
 */
export function fbBoostPaymentPageView(params) {
    return { evid: 189, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPaymentEditPaymentClick' event (evid: 190)
 *
 * Event description: clicking on edit payment link - in facebook
 *
 * @param {fbBoostPaymentEditPaymentClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPaymentEditPaymentClickParams>} LogObject<fbBoostPaymentEditPaymentClickParams>
 */
export function fbBoostPaymentEditPaymentClick(params) {
    return { evid: 190, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPaymentRefreshClick' event (evid: 191)
 *
 * Event description: getting back to payment page after editing in fb
 *
 * @param {fbBoostPaymentRefreshClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPaymentRefreshClickParams>} LogObject<fbBoostPaymentRefreshClickParams>
 */
export function fbBoostPaymentRefreshClick(params) {
    return { evid: 191, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPaymentPlaceAdClick' event (evid: 192)
 *
 * Event description: clicking on place ad button - launch your ad
 *
 * @param {fbBoostPaymentPlaceAdClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostPaymentPlaceAdClickParams>} LogObject<fbBoostPaymentPlaceAdClickParams>
 */
export function fbBoostPaymentPlaceAdClick(params) {
    return { evid: 192, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostPaymentPlaceAdClickSuccess' event (evid: 193)
 *
 * Event description: ad is placed successfully
 *
 * @param {fbBoostPaymentPlaceAdClickSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {number} reachByBudgetMax - reachByBudgetMax
 * @property {string} adurl - ad url
 * @property {number} reachMax - reachMax
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} adCampaignId - ad_campaign_id
 * @property {number} cpm - ad cpm
 * @property {number} reachByBudgetMin - reachByBudgetMin
 * @property {string} adContent - ad Content
 * @property {string} adAccountId - ad_accountId
 * @property {boolean} customAudienceIncluded - custom_audience_Included
 * @property {number} budget - ad budget
 * @property {string} currency - payment currency
 * @property {GUID} msid - msid
 * @property {string} adId - ad ID
 * @return {LogObject<fbBoostPaymentPlaceAdClickSuccessParams>} LogObject<fbBoostPaymentPlaceAdClickSuccessParams>
 */
export function fbBoostPaymentPlaceAdClickSuccess(params) {
    return { evid: 193, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostCongratsPageView' event (evid: 194)
 *
 * Event description: page view
 *
 * @param {fbBoostCongratsPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostCongratsPageViewParams>} LogObject<fbBoostCongratsPageViewParams>
 */
export function fbBoostCongratsPageView(params) {
    return { evid: 194, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostCongratsGoToAdClick' event (evid: 195)
 *
 * Event description: clicking on go to ad
 *
 * @param {fbBoostCongratsGoToAdClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostCongratsGoToAdClickParams>} LogObject<fbBoostCongratsGoToAdClickParams>
 */
export function fbBoostCongratsGoToAdClick(params) {
    return { evid: 195, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostCongratsPostClick' event (evid: 196)
 *
 * Event description: clicking on post to facebook
 *
 * @param {fbBoostCongratsPostClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostCongratsPostClickParams>} LogObject<fbBoostCongratsPostClickParams>
 */
export function fbBoostCongratsPostClick(params) {
    return { evid: 196, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'fbBoostCongratsMySoClick' event (evid: 197)
 *
 * Event description: clicking on my so link
 *
 * @param {fbBoostCongratsMySoClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<fbBoostCongratsMySoClickParams>} LogObject<fbBoostCongratsMySoClickParams>
 */
export function fbBoostCongratsMySoClick(params) {
    return { evid: 197, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'notInUseGetSubscribersSubscribeClick' event (evid: 198)
 *
 * Event description: when users or user clicked "subscribe"
 *
 * @param {notInUseGetSubscribersSubscribeClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<notInUseGetSubscribersSubscribeClickParams>} LogObject<notInUseGetSubscribersSubscribeClickParams>
 */
export function notInUseGetSubscribersSubscribeClick(params) {
    return { evid: 198, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'notInUseGetSubscribersSubscribeSuccess' event (evid: 199)
 *
 * Event description: when getting confirm from the server after clicking on "subscribe"
 * the client get the success from server and send the success event
 *
 * @param {notInUseGetSubscribersSubscribeSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<notInUseGetSubscribersSubscribeSuccessParams>} LogObject<notInUseGetSubscribersSubscribeSuccessParams>
 */
export function notInUseGetSubscribersSubscribeSuccess(params) {
    return { evid: 199, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsPageView' event (evid: 20)
 *
 * Event description: shoutout contacts -> page view.
 *
 * @param {shoutoutContactsPageViewParams} params - The parameters for this event
 * @property {boolean} only_active - true = only actives
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} total_contacts - not in use
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsPageViewParams>} LogObject<shoutoutContactsPageViewParams>
 */
export function shoutoutContactsPageView(params) {
    return { evid: 20, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardWidgetInfoMouseOver' event (evid: 200)
 *
 * Event description: mouse over on the info (i) icon in the widget
 *
 * @param {shoutoutDashboardWidgetInfoMouseOverParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - widget source
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardWidgetInfoMouseOverParams>} LogObject<shoutoutDashboardWidgetInfoMouseOverParams>
 */
export function shoutoutDashboardWidgetInfoMouseOver(params) {
    return { evid: 200, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppShowLandingPage' event (evid: 201)
 *
 * Event description: when user watching an exiting shoutout
 *
 * @param {oneAppShowLandingPageParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id guid
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppShowLandingPageParams>} LogObject<oneAppShowLandingPageParams>
 */
export function oneAppShowLandingPage(params) {
    return { evid: 201, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppOpenShoutoutAppRequest' event (evid: 202)
 *
 * Event description: when user is requested to open shoutout app
 *
 * @param {oneAppOpenShoutoutAppRequestParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id guid
 * @property {GUID} msid - msid
 * @property {string} action - action: "reuse"/"edit"/"newFromTemplate"
 * @return {LogObject<oneAppOpenShoutoutAppRequestParams>} LogObject<oneAppOpenShoutoutAppRequestParams>
 */
export function oneAppOpenShoutoutAppRequest(params) {
    return { evid: 202, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppAppOpenAppstore' event (evid: 204)
 *
 * Event description: open shoutout in appstore if app is not installed on user device
 *
 * @param {oneAppAppOpenAppstoreParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppAppOpenAppstoreParams>} LogObject<oneAppAppOpenAppstoreParams>
 */
export function oneAppAppOpenAppstore(params) {
    return { evid: 204, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppCardAction' event (evid: 205)
 *
 * Event description: fired after clicking a card in one app feed
 *
 * @param {oneAppCardActionParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} card - card:"statsCard"/"welcomeCard"/"newSubscribersCard"
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCardActionParams>} LogObject<oneAppCardActionParams>
 */
export function oneAppCardAction(params) {
    return { evid: 205, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppPageView' event (evid: 206)
 *
 * Event description: distinguish between My Shoutouts or Templates page loading
 *
 * @param {oneAppPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} page_loaded - distinguish between My Shoutouts or Templates page loading
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppPageViewParams>} LogObject<oneAppPageViewParams>
 */
export function oneAppPageView(params) {
    return { evid: 206, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppNoMessages' event (evid: 207)
 *
 * Event description: user has no shotuouts at all (published or drafts)
 *
 * @param {oneAppNoMessagesParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppNoMessagesParams>} LogObject<oneAppNoMessagesParams>
 */
export function oneAppNoMessages(params) {
    return { evid: 207, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'oneAppCreateShoutout' event (evid: 208)
 *
 * Event description: when user is clicking "create shoutout" or "+" button
 *
 * @param {oneAppCreateShoutoutParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - "+" button or "create shoutout" CTA
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCreateShoutoutParams>} LogObject<oneAppCreateShoutoutParams>
 */
export function oneAppCreateShoutout(params) {
    return { evid: 208, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardLearnMoreClick' event (evid: 209)
 *
 * Event description: click on learn more form a widget
 *
 * @param {shoutoutDashboardLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {Url} url - article url link
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - widget source
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardLearnMoreClickParams>} LogObject<shoutoutDashboardLearnMoreClickParams>
 */
export function shoutoutDashboardLearnMoreClick(params) {
    return { evid: 209, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsAddContactsButton' event (evid: 21)
 *
 * Event description: shoutout contacts -> add contacts button.
 *
 * @param {shoutoutContactsAddContactsButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} count - count
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsAddContactsButtonParams>} LogObject<shoutoutContactsAddContactsButtonParams>
 */
export function shoutoutContactsAddContactsButton(params) {
    return { evid: 21, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormNotificationSwitch' event (evid: 210)
 *
 * Event description: Switching email notification on/off
 *
 * @param {getSubscribersSettingsFormNotificationSwitchParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormNotificationSwitchParams>} LogObject<getSubscribersSettingsFormNotificationSwitchParams>
 */
export function getSubscribersSettingsFormNotificationSwitch(params) {
    return { evid: 210, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormMobileMandatory' event (evid: 211)
 *
 * Event description: Checking if mobile is mandatory
 *
 * @param {getSubscribersSettingsFormMobileMandatoryParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormMobileMandatoryParams>} LogObject<getSubscribersSettingsFormMobileMandatoryParams>
 */
export function getSubscribersSettingsFormMobileMandatory(params) {
    return { evid: 211, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormMobileSwitch' event (evid: 212)
 *
 * Event description: Choosing whether to display phone field
 *
 * @param {getSubscribersSettingsFormMobileSwitchParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormMobileSwitchParams>} LogObject<getSubscribersSettingsFormMobileSwitchParams>
 */
export function getSubscribersSettingsFormMobileSwitch(params) {
    return { evid: 212, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormFieldNameMandatory' event (evid: 213)
 *
 * Event description: Checking if name is mandatory
 *
 * @param {getSubscribersSettingsFormFieldNameMandatoryParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormFieldNameMandatoryParams>} LogObject<getSubscribersSettingsFormFieldNameMandatoryParams>
 */
export function getSubscribersSettingsFormFieldNameMandatory(params) {
    return { evid: 213, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormFieldNameSwitch' event (evid: 214)
 *
 * Event description: Choosing whether to display name field
 *
 * @param {getSubscribersSettingsFormFieldNameSwitchParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormFieldNameSwitchParams>} LogObject<getSubscribersSettingsFormFieldNameSwitchParams>
 */
export function getSubscribersSettingsFormFieldNameSwitch(params) {
    return { evid: 214, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSettingsFormTitleCheckboxClick' event (evid: 215)
 *
 * Event description: Hiding/Showing title
 *
 * @param {getSubscribersSettingsFormTitleCheckboxClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} status - true:On, false:Off
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSettingsFormTitleCheckboxClickParams>} LogObject<getSubscribersSettingsFormTitleCheckboxClickParams>
 */
export function getSubscribersSettingsFormTitleCheckboxClick(params) {
    return { evid: 215, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersTabClick' event (evid: 216)
 *
 * Event description: click on one of the tab
 *
 * @param {getSubscribersTabClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} description - description
 * @property {string} tab_name - values: tab_name: settings, layout, design, emails, create
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersTabClickParams>} LogObject<getSubscribersTabClickParams>
 */
export function getSubscribersTabClick(params) {
    return { evid: 216, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersLayoutChangeLayout' event (evid: 217)
 *
 * Event description: Switching between horizontal/vertical
 *
 * @param {getSubscribersLayoutChangeLayoutParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - name: side_layout, below_layout
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersLayoutChangeLayoutParams>} LogObject<getSubscribersLayoutChangeLayoutParams>
 */
export function getSubscribersLayoutChangeLayout(params) {
    return { evid: 217, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shotuoutComplianceArticleLinkClick' event (evid: 218)
 *
 * Event description: click on the article link
 *
 * @param {shotuoutComplianceArticleLinkClickParams} params - The parameters for this event
 * @property {string} article_link_name - Spam_complaints / spam_traps / bounces / low_engagement / read_more
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id
 * @property {string} context
 * @property {GUID} uuid
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 * @property {string} page_name - from which page of the compliance
 * @property {GUID} msid - msid
 * @property {string} compliance_status - Warned / suspended / banned (from server)
 * @return {LogObject<shotuoutComplianceArticleLinkClickParams>} LogObject<shotuoutComplianceArticleLinkClickParams>
 */
export function shotuoutComplianceArticleLinkClick(params) {
    return { evid: 218, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersDesignChangeTemplate' event (evid: 219)
 *
 * Event description: Switching between templates (styles)
 *
 * @param {getSubscribersDesignChangeTemplateParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - name: Classic, Strip, Postcard, Elegant, Headiine
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersDesignChangeTemplateParams>} LogObject<getSubscribersDesignChangeTemplateParams>
 */
export function getSubscribersDesignChangeTemplate(params) {
    return { evid: 219, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsSelectContact' event (evid: 22)
 *
 * Event description: shoutout contacts -> select contact.
 *
 * @param {shoutoutContactsSelectContactParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} method - by which method the user added (new/checkbox/autocomplete)
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} selected - true/false (if the user was selected or deselected)
 * @property {string} type_id - identifier of selected type object
 * @property {string} contact_id - contact_id
 * @property {string} type - select label(group)/contact
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsSelectContactParams>} LogObject<shoutoutContactsSelectContactParams>
 */
export function shoutoutContactsSelectContact(params) {
    return { evid: 22, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shotuoutComplianceCtsClick' event (evid: 220)
 *
 * Event description: click one one of the CTAs
 *
 * @param {shotuoutComplianceCtsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id
 * @property {string} context
 * @property {GUID} uuid
 * @property {string} cta_type - reactivate/contact us/ view tickets/questioner/submit
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 * @property {string} page_name - from which page of the compliance
 * @property {GUID} msid - msid
 * @property {string} compliance_status - Warned / suspended / banned (from server)
 * @return {LogObject<shotuoutComplianceCtsClickParams>} LogObject<shotuoutComplianceCtsClickParams>
 */
export function shotuoutComplianceCtsClick(params) {
    return { evid: 220, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersPopupRemoveOldPopup' event (evid: 221)
 *
 * Event description: When user has OLD popup - click on remove button
 *
 * @param {getSubscribersPopupRemoveOldPopupParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} description - description
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersPopupRemoveOldPopupParams>} LogObject<getSubscribersPopupRemoveOldPopupParams>
 */
export function getSubscribersPopupRemoveOldPopup(params) {
    return { evid: 221, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersEmailsSendBeautifulNewsletter' event (evid: 223)
 *
 * Event description: Clicking on ShoutOut 'Start Now' button
 *
 * @param {getSubscribersEmailsSendBeautifulNewsletterParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} description - description
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersEmailsSendBeautifulNewsletterParams>} LogObject<getSubscribersEmailsSendBeautifulNewsletterParams>
 */
export function getSubscribersEmailsSendBeautifulNewsletter(params) {
    return { evid: 223, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesDynamicTemplateOnProcessDone' event (evid: 224)
 *
 * Event description: templates - choosing a template
 *
 * @param {shoutoutTemplatesDynamicTemplateOnProcessDoneParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} template_list_name - list name(BO) || top/bottom
 * @property {string} template_name - template_name
 * @property {string} context - shoutout/sosa
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutTemplatesDynamicTemplateOnProcessDoneParams>} LogObject<shoutoutTemplatesDynamicTemplateOnProcessDoneParams>
 */
export function shoutoutTemplatesDynamicTemplateOnProcessDone(params) {
    return { evid: 224, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesDynamicTemplateOnProcessCancel' event (evid: 225)
 *
 * Event description: templates - choosing a template
 *
 * @param {shoutoutTemplatesDynamicTemplateOnProcessCancelParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} template_list_name - list name(BO) || top/bottom
 * @property {string} template_name - template_name
 * @property {string} context - shoutout/sosa
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutTemplatesDynamicTemplateOnProcessCancelParams>} LogObject<shoutoutTemplatesDynamicTemplateOnProcessCancelParams>
 */
export function shoutoutTemplatesDynamicTemplateOnProcessCancel(params) {
    return { evid: 225, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsActiveContactsButtonClick' event (evid: 226)
 *
 * Event description: click on the active contacts button to turn off/on the 'only active status'
 *
 * @param {shoutoutContactsActiveContactsButtonClickParams} params - The parameters for this event
 * @property {boolean} only_active - true = only actives
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsActiveContactsButtonClickParams>} LogObject<shoutoutContactsActiveContactsButtonClickParams>
 */
export function shoutoutContactsActiveContactsButtonClick(params) {
    return { evid: 226, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsActiveContactToolTipHover' event (evid: 227)
 *
 * Event description: active contact tool tip hover - opens tool tip view
 *
 * @param {shoutoutContactsActiveContactToolTipHoverParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsActiveContactToolTipHoverParams>} LogObject<shoutoutContactsActiveContactToolTipHoverParams>
 */
export function shoutoutContactsActiveContactToolTipHover(params) {
    return { evid: 227, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsActiveContactLearnMoreClick' event (evid: 228)
 *
 * Event description: click on one of the links for learn more
 *
 * @param {shoutoutContactsActiveContactLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - tooltip/warning massage/good looking/no active users
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsActiveContactLearnMoreClickParams>} LogObject<shoutoutContactsActiveContactLearnMoreClickParams>
 */
export function shoutoutContactsActiveContactLearnMoreClick(params) {
    return { evid: 228, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsNoActiveContactsView' event (evid: 229)
 *
 * Event description: when users have no active users, he gets the no active contacts view
 *
 * @param {shoutoutContactsNoActiveContactsViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsNoActiveContactsViewParams>} LogObject<shoutoutContactsNoActiveContactsViewParams>
 */
export function shoutoutContactsNoActiveContactsView(params) {
    return { evid: 229, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPreviewSwitchViewCta' event (evid: 23)
 *
 * Event description: when user in email preview switches from desktop view to mobile and vice versa
 *
 * @param {shoutoutPreviewSwitchViewCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - application context
 * @property {GUID} uuid - user id
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - the language
 * @property {string} package_name - package_name
 * @property {GUID} msid - msid
 * @property {string} view - mobile/web
 * @return {LogObject<shoutoutPreviewSwitchViewCtaParams>} LogObject<shoutoutPreviewSwitchViewCtaParams>
 */
export function shoutoutPreviewSwitchViewCta(params) {
    return { evid: 23, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsActiveContactToolTipMessageClose' event (evid: 230)
 *
 * Event description: click on close in the tool tip
 *
 * @param {shoutoutContactsActiveContactToolTipMessageCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsActiveContactToolTipMessageCloseParams>} LogObject<shoutoutContactsActiveContactToolTipMessageCloseParams>
 */
export function shoutoutContactsActiveContactToolTipMessageClose(params) {
    return { evid: 230, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsActiveContactToolTipMessageView' event (evid: 231)
 *
 * Event description: when switch off the active contacts- a tool tip message is been shown
 *
 * @param {shoutoutContactsActiveContactToolTipMessageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - page_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsActiveContactToolTipMessageViewParams>} LogObject<shoutoutContactsActiveContactToolTipMessageViewParams>
 */
export function shoutoutContactsActiveContactToolTipMessageView(params) {
    return { evid: 231, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsModalView' event (evid: 232)
 *
 * Event description: generic modal view for the sender details feature
 *
 * @param {senderDetailsModalViewParams} params - The parameters for this event
 * @property {string} modal_type - add sender details, confirmation, success screen
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {string} origin - source of open the modal - 'transactional emails dashboard', 'transactional email composer'
 * @property {string} sender_details_status - verified/unverified
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsModalViewParams>} LogObject<senderDetailsModalViewParams>
 */
export function senderDetailsModalView(params) {
    return { evid: 232, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsModalInfoHoverMessageView' event (evid: 233)
 *
 * Event description: over on info sign in the modal, a message pops out
 *
 * @param {senderDetailsModalInfoHoverMessageViewParams} params - The parameters for this event
 * @property {string} modal_type - add sender details, confirmation, success screen
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - from name, reply to mail
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsModalInfoHoverMessageViewParams>} LogObject<senderDetailsModalInfoHoverMessageViewParams>
 */
export function senderDetailsModalInfoHoverMessageView(params) {
    return { evid: 233, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsModalCtaClick' event (evid: 234)
 *
 * Event description: generic click on one of the modal CTAs
 *
 * @param {senderDetailsModalCtaClickParams} params - The parameters for this event
 * @property {string} modal_type - add sender details, confirmation, success screen
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} url - link for the CTA if it has one
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - exit, cancel, save, confirm, change details, send again, got it
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsModalCtaClickParams>} LogObject<senderDetailsModalCtaClickParams>
 */
export function senderDetailsModalCtaClick(params) {
    return { evid: 234, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsPublicDomainValidationMessageView' event (evid: 235)
 *
 * Event description: when users enter a public domain name he get this message
 *
 * @param {senderDetailsPublicDomainValidationMessageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} domain - the domain that triggered the message
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsPublicDomainValidationMessageViewParams>} LogObject<senderDetailsPublicDomainValidationMessageViewParams>
 */
export function senderDetailsPublicDomainValidationMessageView(params) {
    return { evid: 235, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsPublicDomainValidationMessageCtaClick' event (evid: 236)
 *
 * Event description: click on the message cta for purchace mail box
 *
 * @param {senderDetailsPublicDomainValidationMessageCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} domain - the domain that triggered the message
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - purchace mail box
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsPublicDomainValidationMessageCtaClickParams>} LogObject<senderDetailsPublicDomainValidationMessageCtaClickParams>
 */
export function senderDetailsPublicDomainValidationMessageCtaClick(params) {
    return { evid: 236, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsConfirmationSuccess' event (evid: 237)
 *
 * Event description: after click on the confirm cta in the last modal  - this event been fired
 *
 * @param {senderDetailsConfirmationSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} success - true - code is good, false - code is wrong
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - the app which the feature was opened from
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsConfirmationSuccessParams>} LogObject<senderDetailsConfirmationSuccessParams>
 */
export function senderDetailsConfirmationSuccess(params) {
    return { evid: 237, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teFirstTimeExperienceView' event (evid: 238)
 *
 * Event description: first time page load
 *
 * @param {teFirstTimeExperienceViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teFirstTimeExperienceViewParams>} LogObject<teFirstTimeExperienceViewParams>
 */
export function teFirstTimeExperienceView(params) {
    return { evid: 238, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teFirstTimeGetStartedClick' event (evid: 239)
 *
 * Event description: click o the get started button
 *
 * @param {teFirstTimeGetStartedClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - header/first-time
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teFirstTimeGetStartedClickParams>} LogObject<teFirstTimeGetStartedClickParams>
 */
export function teFirstTimeGetStartedClick(params) {
    return { evid: 239, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsNextPage' event (evid: 24)
 *
 * Event description: shoutout contacts -> next page.
 *
 * @param {shoutoutContactsNextPageParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} count - count
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsNextPageParams>} LogObject<shoutoutContactsNextPageParams>
 */
export function shoutoutContactsNextPage(params) {
    return { evid: 24, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teFirstTimeLearnMoreClick' event (evid: 240)
 *
 * Event description: click on the learn more link
 *
 * @param {teFirstTimeLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teFirstTimeLearnMoreClickParams>} LogObject<teFirstTimeLearnMoreClickParams>
 */
export function teFirstTimeLearnMoreClick(params) {
    return { evid: 240, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentAddDynamicVariableClick' event (evid: 241)
 *
 * Event description: click to add a variable
 *
 * @param {teTextComponentAddDynamicVariableClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - text-region/subject
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentAddDynamicVariableClickParams>} LogObject<teTextComponentAddDynamicVariableClickParams>
 */
export function teTextComponentAddDynamicVariableClick(params) {
    return { evid: 241, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentDynamicVariableModalView' event (evid: 242)
 *
 * Event description: dynamic variable modal view open
 *
 * @param {teTextComponentDynamicVariableModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - text-region/subject
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentDynamicVariableModalViewParams>} LogObject<teTextComponentDynamicVariableModalViewParams>
 */
export function teTextComponentDynamicVariableModalView(params) {
    return { evid: 242, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentDynamicVariableModalClose' event (evid: 243)
 *
 * Event description: close the dynamic variable
 *
 * @param {teTextComponentDynamicVariableModalCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - text-region/subject
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentDynamicVariableModalCloseParams>} LogObject<teTextComponentDynamicVariableModalCloseParams>
 */
export function teTextComponentDynamicVariableModalClose(params) {
    return { evid: 243, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentDynamicVariableModalCancel' event (evid: 244)
 *
 * Event description: cancel to close the dynamic variable
 *
 * @param {teTextComponentDynamicVariableModalCancelParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - text-region/subject
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentDynamicVariableModalCancelParams>} LogObject<teTextComponentDynamicVariableModalCancelParams>
 */
export function teTextComponentDynamicVariableModalCancel(params) {
    return { evid: 244, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentDynamicVariableModalAddClick' event (evid: 245)
 *
 * Event description: save and close the modal
 *
 * @param {teTextComponentDynamicVariableModalAddClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} fallback_value - fallback value
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} variable_name - variable value
 * @property {string} type - text-region/subject
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentDynamicVariableModalAddClickParams>} LogObject<teTextComponentDynamicVariableModalAddClickParams>
 */
export function teTextComponentDynamicVariableModalAddClick(params) {
    return { evid: 245, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teTextComponentDynamicVariableModalLearnMoreClick' event (evid: 246)
 *
 * Event description: close the dynamic variable
 *
 * @param {teTextComponentDynamicVariableModalLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - text-region/subject
 * @property {GUID} msid - msid
 * @return {LogObject<teTextComponentDynamicVariableModalLearnMoreClickParams>} LogObject<teTextComponentDynamicVariableModalLearnMoreClickParams>
 */
export function teTextComponentDynamicVariableModalLearnMoreClick(params) {
    return { evid: 246, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSubjectLineClick' event (evid: 247)
 *
 * Event description: click to edit the subject line (input is in focus)
 *
 * @param {teSubjectLineClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teSubjectLineClickParams>} LogObject<teSubjectLineClickParams>
 */
export function teSubjectLineClick(params) {
    return { evid: 247, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSubjectLineLearnMoreClick' event (evid: 248)
 *
 * Event description: action that finish and save the subject line
 *
 * @param {teSubjectLineLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teSubjectLineLearnMoreClickParams>} LogObject<teSubjectLineLearnMoreClickParams>
 */
export function teSubjectLineLearnMoreClick(params) {
    return { evid: 248, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSaveAsDraftClick' event (evid: 249)
 *
 * Event description: click on save as draft in the composer
 *
 * @param {teSaveAsDraftClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teSaveAsDraftClickParams>} LogObject<teSaveAsDraftClickParams>
 */
export function teSaveAsDraftClick(params) {
    return { evid: 249, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutUpgradePromotionView' event (evid: 25)
 *
 * Event description: promotion view shown (tooltip/modal/others) UPGRADE_PROMOTION_VIEW
 *
 * @param {shoutoutUpgradePromotionViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id -  vendor product id
 * @property {string} quota_type -  quota type (messages/emails)
 * @property {string} promotion_type -  type of promotion
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group -  Free/Basic/Business/Pro
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} page_name -  page user is in
 * @property {GUID} msid -  msid
 * @return {LogObject<shoutoutUpgradePromotionViewParams>} LogObject<shoutoutUpgradePromotionViewParams>
 */
export function shoutoutUpgradePromotionView(params) {
    return { evid: 25, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSenderDetailsClick' event (evid: 250)
 *
 * Event description: click to edit sender details in the TE dashboard page
 *
 * @param {teSenderDetailsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - new,edit
 * @property {GUID} msid - msid
 * @return {LogObject<teSenderDetailsClickParams>} LogObject<teSenderDetailsClickParams>
 */
export function teSenderDetailsClick(params) {
    return { evid: 250, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teMessageDetailsModalView' event (evid: 251)
 *
 * Event description: when click on save  and published and sender details are sets. get the success modal
 * or when clicking  on code script from the dashboard. this event contain subject value so we know the last value of the subject or if the user changed it
 *
 * @param {teMessageDetailsModalViewParams} params - The parameters for this event
 * @property {string} modal_type - published success,code snippets
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subject - subject
 * @property {string} email_id - email_id
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {number} number_of_placeholders - number_of_placeholders
 * @property {GUID} msid - msid
 * @return {LogObject<teMessageDetailsModalViewParams>} LogObject<teMessageDetailsModalViewParams>
 */
export function teMessageDetailsModalView(params) {
    return { evid: 251, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teMessageDetailsModalCtaClick' event (evid: 252)
 *
 * Event description: click on a cta in the modal
 *
 * @param {teMessageDetailsModalCtaClickParams} params - The parameters for this event
 * @property {string} modal_type - published success,code snippets
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subject - subject
 * @property {string} email_id - email_id
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - got it
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {number} number_of_placeholders - number_of_placeholders
 * @property {GUID} msid - msid
 * @return {LogObject<teMessageDetailsModalCtaClickParams>} LogObject<teMessageDetailsModalCtaClickParams>
 */
export function teMessageDetailsModalCtaClick(params) {
    return { evid: 252, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teMessageDetailsModalEditEmailId' event (evid: 253)
 *
 * Event description: edit and save a new value for email id
 *
 * @param {teMessageDetailsModalEditEmailIdParams} params - The parameters for this event
 * @property {string} modal_type - published success,code snippets
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} email_id - email_id
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teMessageDetailsModalEditEmailIdParams>} LogObject<teMessageDetailsModalEditEmailIdParams>
 */
export function teMessageDetailsModalEditEmailId(params) {
    return { evid: 253, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teMessageDetailsModalCopy' event (evid: 254)
 *
 * Event description: click on copy script or email id
 *
 * @param {teMessageDetailsModalCopyParams} params - The parameters for this event
 * @property {string} modal_type - published success,code snippets
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} email_id - email_id
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {string} type - email_id,script,contacts-script,registered-script
 * @property {GUID} msid - msid
 * @return {LogObject<teMessageDetailsModalCopyParams>} LogObject<teMessageDetailsModalCopyParams>
 */
export function teMessageDetailsModalCopy(params) {
    return { evid: 254, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teLeaveEditModeModalView' event (evid: 255)
 *
 * Event description: when leaving in the middle of editing a published, gets a warning message modal
 *
 * @param {teLeaveEditModeModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teLeaveEditModeModalViewParams>} LogObject<teLeaveEditModeModalViewParams>
 */
export function teLeaveEditModeModalView(params) {
    return { evid: 255, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teLeaveEditModeModalCtaClick' event (evid: 256)
 *
 * Event description: when leaving in the middle of editting a published, gets a warning message modal
 *
 * @param {teLeaveEditModeModalCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - confirm,cancel,close
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teLeaveEditModeModalCtaClickParams>} LogObject<teLeaveEditModeModalCtaClickParams>
 */
export function teLeaveEditModeModalCtaClick(params) {
    return { evid: 256, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teEditPublishedWarningModalView' event (evid: 257)
 *
 * Event description: when edit a publushed, gets a blue line on the top of the screen with warning
 *
 * @param {teEditPublishedWarningModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teEditPublishedWarningModalViewParams>} LogObject<teEditPublishedWarningModalViewParams>
 */
export function teEditPublishedWarningModalView(params) {
    return { evid: 257, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teEditPublishedWarningNotificationCloseClick' event (evid: 258)
 *
 * Event description: when edit a publushed, gets a blue line on th etop with warning, click to close
 *
 * @param {teEditPublishedWarningNotificationCloseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teEditPublishedWarningNotificationCloseClickParams>} LogObject<teEditPublishedWarningNotificationCloseClickParams>
 */
export function teEditPublishedWarningNotificationCloseClick(params) {
    return { evid: 258, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teDashboardView' event (evid: 259)
 *
 * Event description: open the TE dashboard page view
 *
 * @param {teDashboardViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} sender_page_status - sender details is set or not
 * @property {string} sender_details_status - sender details is set or not
 * @property {GUID} msid - msid
 * @return {LogObject<teDashboardViewParams>} LogObject<teDashboardViewParams>
 */
export function teDashboardView(params) {
    return { evid: 259, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teOpenComposer' event (evid: 260)
 *
 * Event description: open the TE composer page view
 *
 * @param {teOpenComposerParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subject - the subject in the message
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - referral of open composer
 * @property {string} components_data - Json with all components data and number of componet
 * @property {string} sender_page_status - sender details is set or not
 * @property {string} sender_details_status - sender details is set or not
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @property {string} campaign_id - campaign id
 * @return {LogObject<teOpenComposerParams>} LogObject<teOpenComposerParams>
 */
export function teOpenComposer(params) {
    return { evid: 260, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutLpPageView261' event (evid: 261)
 *
 * Event description: on click of the "shoutout my shoutout -> view lp click"
 *
 * @param {shoutoutLpPageView261Params} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutLpPageView261Params>} LogObject<shoutoutLpPageView261Params>
 */
export function shoutoutLpPageView261(params) {
    return { evid: 261, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teCreateNewTe' event (evid: 262)
 *
 * Event description: click to create a new TE which will open the composer
 *
 * @param {teCreateNewTeParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - which of the exist buttons clicked on
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<teCreateNewTeParams>} LogObject<teCreateNewTeParams>
 */
export function teCreateNewTe(params) {
    return { evid: 262, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teHelpIconClick' event (evid: 263)
 *
 * Event description: click on the 'find out how' (help icon) mark in the lower right side of the screan
 *
 * @param {teHelpIconClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} sender_details_status - verified/unverified
 * @property {GUID} msid - msid
 * @return {LogObject<teHelpIconClickParams>} LogObject<teHelpIconClickParams>
 */
export function teHelpIconClick(params) {
    return { evid: 263, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teMessageDetailsLearnMoreClick' event (evid: 264)
 *
 * Event description: in the message details modal, click on learn more
 *
 * @param {teMessageDetailsLearnMoreClickParams} params - The parameters for this event
 * @property {string} modal_type - published success,code snippets
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} email_id - email_id
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teMessageDetailsLearnMoreClickParams>} LogObject<teMessageDetailsLearnMoreClickParams>
 */
export function teMessageDetailsLearnMoreClick(params) {
    return { evid: 264, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'tePublishClick' event (evid: 265)
 *
 * Event description: click on save and publish
 *
 * @param {tePublishClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} subject - subject
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {number} number_of_placeholders - number_of_placeholders
 * @property {GUID} msid - msid
 * @return {LogObject<tePublishClickParams>} LogObject<tePublishClickParams>
 */
export function tePublishClick(params) {
    return { evid: 265, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSenderDetailsMissingModalView' event (evid: 266)
 *
 * Event description: when click on save and published and sender details is not set we get this modal
 *
 * @param {teSenderDetailsMissingModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSenderDetailsMissingModalViewParams>} LogObject<teSenderDetailsMissingModalViewParams>
 */
export function teSenderDetailsMissingModalView(params) {
    return { evid: 266, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSenderDetailsMissingModalClose' event (evid: 267)
 *
 * Event description: click on the X to close
 *
 * @param {teSenderDetailsMissingModalCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSenderDetailsMissingModalCloseParams>} LogObject<teSenderDetailsMissingModalCloseParams>
 */
export function teSenderDetailsMissingModalClose(params) {
    return { evid: 267, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSenderDetailsMissingModalCtaClick' event (evid: 268)
 *
 * Event description: click on one of the modal ctas
 *
 * @param {teSenderDetailsMissingModalCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - name of button clicked
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSenderDetailsMissingModalCtaClickParams>} LogObject<teSenderDetailsMissingModalCtaClickParams>
 */
export function teSenderDetailsMissingModalCtaClick(params) {
    return { evid: 268, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSavingChangesModalView' event (evid: 269)
 *
 * Event description: open a published to edit and click on save you get this modal
 *
 * @param {teSavingChangesModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSavingChangesModalViewParams>} LogObject<teSavingChangesModalViewParams>
 */
export function teSavingChangesModalView(params) {
    return { evid: 269, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSavingChangesModalCtaClick' event (evid: 270)
 *
 * Event description: open a published to edit and click on save you get this modal
 *
 * @param {teSavingChangesModalCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cancel,save
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSavingChangesModalCtaClickParams>} LogObject<teSavingChangesModalCtaClickParams>
 */
export function teSavingChangesModalCtaClick(params) {
    return { evid: 270, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teAutoAutomationsWidgetView' event (evid: 271)
 *
 * Event description: when a preview of a template is previewed in a wi
 *
 * @param {teAutoAutomationsWidgetViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - action_id
 * @property {boolean} is_multilingual - if site is multilingual
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - rule_id
 * @property {GUID} message_id - message_id
 * @property {string} sender_details_status - verified/unverified
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teAutoAutomationsWidgetViewParams>} LogObject<teAutoAutomationsWidgetViewParams>
 */
export function teAutoAutomationsWidgetView(params) {
    return { evid: 271, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teAutoAutomationsWidgetCtaClick' event (evid: 272)
 *
 * Event description: click on a cta in the template widget
 *
 * @param {teAutoAutomationsWidgetCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - action_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - edit,preview
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - rule_id
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teAutoAutomationsWidgetCtaClickParams>} LogObject<teAutoAutomationsWidgetCtaClickParams>
 */
export function teAutoAutomationsWidgetCtaClick(params) {
    return { evid: 272, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teAutoSaveClick' event (evid: 273)
 *
 * Event description: in the composer, click on save
 *
 * @param {teAutoSaveClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - action_id
 * @property {string} subject - the subject in the message
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - rule_id
 * @property {GUID} message_id - message_id
 * @property {number} number_of_placeholders - number_of_placeholders
 * @property {GUID} msid - msid
 * @property {GUID} template_id - tmeplate id
 * @return {LogObject<teAutoSaveClickParams>} LogObject<teAutoSaveClickParams>
 */
export function teAutoSaveClick(params) {
    return { evid: 273, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teAutoSaveSuccess' event (evid: 274)
 *
 * Event description: success event for save new automation shoutout
 *
 * @param {teAutoSaveSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - action_id
 * @property {string} subject - the subject in the message
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - rule_id
 * @property {string} components_data - Json with all components data and number of componet
 * @property {GUID} message_id - message_id
 * @property {number} number_of_placeholders - number_of_placeholders
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<teAutoSaveSuccessParams>} LogObject<teAutoSaveSuccessParams>
 */
export function teAutoSaveSuccess(params) {
    return { evid: 274, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemPropertyEditClick' event (evid: 275)
 *
 * Event description: when edit the text click on one of the item options like bold, directions ....
 *
 * @param {shoutoutComposeItemPropertyEditClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} interaction_type - How the user edited the property. Slider, input, toggle, drop-down, etc.
 * @property {string} package_id - package_name
 * @property {string} tab - tab
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} user_define - custom, offering
 * @property {string} property_value - value of the property , or for toggle actions (remove /add )
 * @property {string} property - bold, underline, color....
 * @property {string} panel_type - panel_type
 * @property {string} type - item type  - text, button, link, background, inner background
 * @property {GUID} msid - msid
 * @property {GUID} regionId - ID of the region that had a property change
 * @property {string} item - item
 * @return {LogObject<shoutoutComposeItemPropertyEditClickParams>} LogObject<shoutoutComposeItemPropertyEditClickParams>
 */
export function shoutoutComposeItemPropertyEditClick(params) {
    return { evid: 275, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlViewIntroductionModal' event (evid: 276)
 *
 * Event description: view the introduction modal of html - once per metasite
 *
 * @param {shoutoutHtmlViewIntroductionModalParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlViewIntroductionModalParams>} LogObject<shoutoutHtmlViewIntroductionModalParams>
 */
export function shoutoutHtmlViewIntroductionModal(params) {
    return { evid: 276, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teOpenApp' event (evid: 277)
 *
 * Event description: open app - cross
 *
 * @param {teOpenAppParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - open source
 * @property {GUID} msid - msid
 * @return {LogObject<teOpenAppParams>} LogObject<teOpenAppParams>
 */
export function teOpenApp(params) {
    return { evid: 277, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlIntroductionModalLearnMoreClick' event (evid: 278)
 *
 * Event description: click on the learn more button on the modal
 *
 * @param {shoutoutHtmlIntroductionModalLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlIntroductionModalLearnMoreClickParams>} LogObject<shoutoutHtmlIntroductionModalLearnMoreClickParams>
 */
export function shoutoutHtmlIntroductionModalLearnMoreClick(params) {
    return { evid: 278, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlIntroductionModalClose' event (evid: 279)
 *
 * Event description: closed the modal by got it or by pressing on X
 *
 * @param {shoutoutHtmlIntroductionModalCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - "got it", "xButton"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlIntroductionModalCloseParams>} LogObject<shoutoutHtmlIntroductionModalCloseParams>
 */
export function shoutoutHtmlIntroductionModalClose(params) {
    return { evid: 279, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardNewsFeedClick' event (evid: 28)
 *
 * Event description: DASHBOARD_NEWS_FEED_CLICK
 *
 * @param {shoutoutDashboardNewsFeedClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package type
 * @property {string} context - opening context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} title - news feed title
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardNewsFeedClickParams>} LogObject<shoutoutDashboardNewsFeedClickParams>
 */
export function shoutoutDashboardNewsFeedClick(params) {
    return { evid: 28, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlViewNotificationModal' event (evid: 280)
 *
 * Event description: view the notification modal for old email
 *
 * @param {shoutoutHtmlViewNotificationModalParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlViewNotificationModalParams>} LogObject<shoutoutHtmlViewNotificationModalParams>
 */
export function shoutoutHtmlViewNotificationModal(params) {
    return { evid: 280, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlNotificationModalLearnMoreClick' event (evid: 281)
 *
 * Event description: click on the learn more button on the modal
 *
 * @param {shoutoutHtmlNotificationModalLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlNotificationModalLearnMoreClickParams>} LogObject<shoutoutHtmlNotificationModalLearnMoreClickParams>
 */
export function shoutoutHtmlNotificationModalLearnMoreClick(params) {
    return { evid: 281, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutHtmlNotificationModalClose' event (evid: 282)
 *
 * Event description: closed the modal by got it or by pressing on X
 *
 * @param {shoutoutHtmlNotificationModalCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - "got it", "xButton"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutHtmlNotificationModalCloseParams>} LogObject<shoutoutHtmlNotificationModalCloseParams>
 */
export function shoutoutHtmlNotificationModalClose(params) {
    return { evid: 282, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardMoreTemplateClick' event (evid: 283)
 *
 * Event description: in the dashboard - click on more template button to get to the template page
 *
 * @param {shoutoutDashboardMoreTemplateClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} templatesList - templates list loaded to user in dashboard - for  impressions
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardMoreTemplateClickParams>} LogObject<shoutoutDashboardMoreTemplateClickParams>
 */
export function shoutoutDashboardMoreTemplateClick(params) {
    return { evid: 283, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutotuTemplateStartFromScratch' event (evid: 284)
 *
 * Event description: in template page  - click on start from scratch
 *
 * @param {shoutotuTemplateStartFromScratchParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - top/bottom
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} page_name - the name of the page: "dashboard"/"templates"
 * @property {string} templatesList - templates list loaded to user in template page - for  impressions
 * @property {GUID} msid - msid
 * @return {LogObject<shoutotuTemplateStartFromScratchParams>} LogObject<shoutotuTemplateStartFromScratchParams>
 */
export function shoutotuTemplateStartFromScratch(params) {
    return { evid: 284, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeInitiateShoutoutTemplate' event (evid: 285)
 *
 * Event description: when clicking on template for open composer, this event will include the template data for cases the composer event 11 cant load it...
 *
 * @param {shoutoutComposeInitiateShoutoutTemplateParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} template_name - template_name
 * @property {string} tags - tags injected in composer
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - source from where the users open the composer
 * @property {string} messageId - the message id if exists in cases of old integrations
 * @property {string} integrationType - example:  use-template/selected-contacts/batch/undefined
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<shoutoutComposeInitiateShoutoutTemplateParams>} LogObject<shoutoutComposeInitiateShoutoutTemplateParams>
 */
export function shoutoutComposeInitiateShoutoutTemplate(params) {
    return { evid: 285, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPanelPanelView' event (evid: 286)
 *
 * Event description: User has viewed a panel in Wix Emails
 *
 * @param {shoutoutPanelPanelViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} tab - Design, Style, Content, none
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} product_name - product_name
 * @property {boolean} site_theme_available - true / false
 * @property {string} metadata - field for custom values in the event: Map[string:string]
 * @property {string} content_data_id - used to identify campaign content
 * @property {string} panel_type - add an item, style, background,
 * @property {GUID} msid - msid
 * @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 * @return {LogObject<shoutoutPanelPanelViewParams>} LogObject<shoutoutPanelPanelViewParams>
 */
export function shoutoutPanelPanelView(params) {
    return { evid: 286, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPanelPanelItemCtaClick' event (evid: 287)
 *
 * Event description: when a new type of panel is loaded
 *
 * @param {shoutoutPanelPanelItemCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} tab - Design, Style, Content, none
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cancel, apply, add vairiable
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} panel_type - add an item, style, background,
 * @property {GUID} msid - msid
 * @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 * @return {LogObject<shoutoutPanelPanelItemCtaClickParams>} LogObject<shoutoutPanelPanelItemCtaClickParams>
 */
export function shoutoutPanelPanelItemCtaClick(params) {
    return { evid: 287, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPanelPropertyError' event (evid: 288)
 *
 * Event description: after apply click, for each property send event if there is an error message
 *
 * @param {shoutoutPanelPropertyErrorParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} tab - Design, Style, Content, none
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} error_type - invalid url, missing button title... (translation key)
 * @property {string} property_value - Property Value
 * @property {string} property - bold, underline, color.
 * @property {string} panel_type - add an item, style, background,
 * @property {GUID} msid - msid
 * @property {string} item - item under each panel type (footer settings,inner background,outer backgrounf settings,text...), None
 * @return {LogObject<shoutoutPanelPropertyErrorParams>} LogObject<shoutoutPanelPropertyErrorParams>
 */
export function shoutoutPanelPropertyError(params) {
    return { evid: 288, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutResendModalClose' event (evid: 29)
 *
 * Event description: When user closes resend to non-openers modal by clicking on X or cancel
 *
 * @param {shoutoutResendModalCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutResendModalCloseParams>} LogObject<shoutoutResendModalCloseParams>
 */
export function shoutoutResendModalClose(params) {
    return { evid: 29, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageScheduleButton' event (evid: 292)
 *
 * Event description: click on schedule in the send page
 *
 * @param {shoutoutSendPageScheduleButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageScheduleButtonParams>} LogObject<shoutoutSendPageScheduleButtonParams>
 */
export function shoutoutSendPageScheduleButton(params) {
    return { evid: 292, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageModalView' event (evid: 293)
 *
 * Event description: when a modal is open in the send page (error)
 *
 * @param {shoutoutSendPageModalViewParams} params - The parameters for this event
 * @property {string} modal_type - error
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageModalViewParams>} LogObject<shoutoutSendPageModalViewParams>
 */
export function shoutoutSendPageModalView(params) {
    return { evid: 293, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageModalClick' event (evid: 294)
 *
 * Event description: click in the modal in the send page
 *
 * @param {shoutoutSendPageModalClickParams} params - The parameters for this event
 * @property {string} modal_type - the name of the modal, example "error modal"
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cancel try again
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageModalClickParams>} LogObject<shoutoutSendPageModalClickParams>
 */
export function shoutoutSendPageModalClick(params) {
    return { evid: 294, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutouts3DotsActionClick' event (evid: 295)
 *
 * Event description: click on an action in 3 dots in "my shoutouts" or "dashboard"
 *
 * @param {shoutoutMyShoutouts3DotsActionClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} message_type - the label of the post (published, scheduled, etc...)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} campaign_source - web/mobile
 * @property {GUID} message_id - if exists
 * @property {string} type - campaign / template
 * @property {GUID} msid - msid
 * @property {string} action - send now, pause, duplicate, delete
 * @return {LogObject<shoutoutMyShoutouts3DotsActionClickParams>} LogObject<shoutoutMyShoutouts3DotsActionClickParams>
 */
export function shoutoutMyShoutouts3DotsActionClick(params) {
    return { evid: 295, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutsModalView' event (evid: 296)
 *
 * Event description: modal view in "my shoutouts" page
 *
 * @param {shoutoutMyShoutoutsModalViewParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (send, pause)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutsModalViewParams>} LogObject<shoutoutMyShoutoutsModalViewParams>
 */
export function shoutoutMyShoutoutsModalView(params) {
    return { evid: 296, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutsModalClick' event (evid: 297)
 *
 * Event description: click on modal in "my shoutouts" page
 *
 * @param {shoutoutMyShoutoutsModalClickParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (send, pause)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - send, pause, cancel
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutsModalClickParams>} LogObject<shoutoutMyShoutoutsModalClickParams>
 */
export function shoutoutMyShoutoutsModalClick(params) {
    return { evid: 297, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardModalView' event (evid: 298)
 *
 * Event description: User has viewed any modal in Wix Emails
 *
 * @param {shoutoutDashboardModalViewParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (send, pause)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - if relevant (scheduler cta/e dots)
 * @property {string} metadata - field for custom values in the event: Map[string:string]
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardModalViewParams>} LogObject<shoutoutDashboardModalViewParams>
 */
export function shoutoutDashboardModalView(params) {
    return { evid: 298, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardModalClick' event (evid: 299)
 *
 * Event description: Any modal action done by the user in Wix Emails
 *
 * @param {shoutoutDashboardModalClickParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (send, pause)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - send, pause, cancel
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - origin
 * @property {string} metadata - field for custom values in the event: Map[string:string]
 * @property {GUID} msid - msid
 * @property {string} value - updated value (created for toggle)
 * @return {LogObject<shoutoutDashboardModalClickParams>} LogObject<shoutoutDashboardModalClickParams>
 */
export function shoutoutDashboardModalClick(params) {
    return { evid: 299, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPagePageView' event (evid: 30)
 *
 * Event description: shoutout send page -> page view.
 *
 * @param {shoutoutSendPagePageViewParams} params - The parameters for this event
 * @property {boolean} only_active - true = only actives
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} isRecipientsSelected - is_recipients_selected in contact page
 * @property {GUID} msid - msid
 * @property {string} message_id - message_id
 * @return {LogObject<shoutoutSendPagePageViewParams>} LogObject<shoutoutSendPagePageViewParams>
 */
export function shoutoutSendPagePageView(params) {
    return { evid: 30, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSubscribeClick' event (evid: 300)
 *
 * Event description: when users clicked "subscribe"
 *
 * @param {getSubscribersSubscribeClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSubscribeClickParams>} LogObject<getSubscribersSubscribeClickParams>
 */
export function getSubscribersSubscribeClick(params) {
    return { evid: 300, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersSubscribeSuccess' event (evid: 301)
 *
 * Event description: when getting confirm from the server after clicking on "subscribe"
 *
 * @param {getSubscribersSubscribeSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersSubscribeSuccessParams>} LogObject<getSubscribersSubscribeSuccessParams>
 */
export function getSubscribersSubscribeSuccess(params) {
    return { evid: 301, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersAppLoading' event (evid: 302)
 *
 * Event description: event triggered when the app got called from the server. after server event 36:1012.
 *
 * @param {getSubscribersAppLoadingParams} params - The parameters for this event
 * @property {GUID} _event_hash - event_hash
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - visitor session ID
 * @property {GUID} ownerId - owner_id
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersAppLoadingParams>} LogObject<getSubscribersAppLoadingParams>
 */
export function getSubscribersAppLoading(params) {
    return { evid: 302, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'getSubscribersBeatAfterLoaded' event (evid: 303)
 *
 * Event description: event triggered when the app loaded -after 0, 2 and 4 seconds . its debug event for app loading. after "0" suppose to be equal to 19/643 the app is loaded.
 *
 * @param {getSubscribersBeatAfterLoadedParams} params - The parameters for this event
 * @property {GUID} _event_hash - event_hash
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} visitor_id - visitor_id
 * @property {number} second_of_beat - 2,4
 * @property {GUID} vsi - visitor session ID
 * @property {GUID} ownerId - owner_id
 * @property {GUID} msid - msid
 * @return {LogObject<getSubscribersBeatAfterLoadedParams>} LogObject<getSubscribersBeatAfterLoadedParams>
 */
export function getSubscribersBeatAfterLoaded(params) {
    return { evid: 303, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutsCardClickOnAction' event (evid: 304)
 *
 * Event description: click on one of the actions in "my shoutouts" page - instead of existing events
 *
 * @param {shoutoutMyShoutoutsCardClickOnActionParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - action name
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard,my campaigns
 * @property {string} package_group - package_group
 * @property {string} message_type - published, draft, schedule, etc...
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} campaign_source - web/mobile
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} value - action value
 * @return {LogObject<shoutoutMyShoutoutsCardClickOnActionParams>} LogObject<shoutoutMyShoutoutsCardClickOnActionParams>
 */
export function shoutoutMyShoutoutsCardClickOnAction(params) {
    return { evid: 304, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposerModalView' event (evid: 305)
 *
 * Event description: any modal that is been opened in the composer page (we are stopping using this event, and instead we will use the generic one 298)
 *
 * @param {shoutoutComposerModalViewParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (new composer update))
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message_id - if exists
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposerModalViewParams>} LogObject<shoutoutComposerModalViewParams>
 */
export function shoutoutComposerModalView(params) {
    return { evid: 305, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposerModalCtaClick' event (evid: 306)
 *
 * Event description: any modal that is been opened in the composer page, click on one of the CTAs in side the modal
 *
 * @param {shoutoutComposerModalCtaClickParams} params - The parameters for this event
 * @property {string} modal_type - the type of the modal (send, pause)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - send, pause, cancel
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message_id - if exists
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposerModalCtaClickParams>} LogObject<shoutoutComposerModalCtaClickParams>
 */
export function shoutoutComposerModalCtaClick(params) {
    return { evid: 306, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeItemDuplicateClick' event (evid: 307)
 *
 * Event description: when the user clicks on duplicate on an item on stage in the composer
 *
 * @param {shoutoutComposeItemDuplicateClickParams} params - The parameters for this event
 * @property {boolean} is_title - is title region
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} package_name - package_name
 * @property {string} type - the type of the item(text,rsvp,music,button, etc....)
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeItemDuplicateClickParams>} LogObject<shoutoutComposeItemDuplicateClickParams>
 */
export function shoutoutComposeItemDuplicateClick(params) {
    return { evid: 307, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageClickAddSubjectVariable' event (evid: 308)
 *
 * Event description: beside the subject line, click on the cta to add a variable , a list of options will be opened.
 *
 * @param {shoutoutSendPageClickAddSubjectVariableParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageClickAddSubjectVariableParams>} LogObject<shoutoutSendPageClickAddSubjectVariableParams>
 */
export function shoutoutSendPageClickAddSubjectVariable(params) {
    return { evid: 308, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageChooseSubjectVariableValue' event (evid: 309)
 *
 * Event description: beside the subject line, click on the cta to add a variable , a list of options will be opened, and then the users choose a variable type
 *
 * @param {shoutoutSendPageChooseSubjectVariableValueParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {string} variable_name - variable_name
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageChooseSubjectVariableValueParams>} LogObject<shoutoutSendPageChooseSubjectVariableValueParams>
 */
export function shoutoutSendPageChooseSubjectVariableValue(params) {
    return { evid: 309, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageNameFocus' event (evid: 31)
 *
 * Event description: shoutout send page -> name focus.
 *
 * @param {shoutoutSendPageNameFocusParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageNameFocusParams>} LogObject<shoutoutSendPageNameFocusParams>
 */
export function shoutoutSendPageNameFocus(params) {
    return { evid: 31, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'firstTimeExperiencePageView' event (evid: 311)
 *
 * Event description: first time experience page been loaded
 *
 * @param {firstTimeExperiencePageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {GUID} template_list_id - shown template list id
 * @property {string} template_ids - list of template ids shown to user
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - source from where the users open the composer
 * @property {number} no_of_subscribers - number of subscribers user has
 * @property {GUID} msid - msid
 * @property {string} template_names - list of template names shown to user
 * @return {LogObject<firstTimeExperiencePageViewParams>} LogObject<firstTimeExperiencePageViewParams>
 */
export function firstTimeExperiencePageView(params) {
    return { evid: 311, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'firstTimeExperienceCtaClick' event (evid: 312)
 *
 * Event description: generic event for cta click in the first time experience page
 *
 * @param {firstTimeExperienceCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} template_name - selected template name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - start (currently the only value)
 * @property {GUID} template_list_id - selected template list id
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} position - index position of selected template
 * @property {GUID} msid - msid
 * @property {string} template_id - selected template id
 * @return {LogObject<firstTimeExperienceCtaClickParams>} LogObject<firstTimeExperienceCtaClickParams>
 */
export function firstTimeExperienceCtaClick(params) {
    return { evid: 312, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsTabView' event (evid: 313)
 *
 * Event description: when the user views each one of the tabs in the stat page
 *
 * @param {shoutoutStatsTabViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} prev_tab - "the previous tab the user was on before views this on,  if this is the first one then return 'no prev tab'"
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - NA
 * @property {string} origin - "the origin to the page, where the user came from: optional values: dashboard/my shoutouts"
 * @property {string} tab_status - "the status of the tab, if empty or not optional values: empty_state/full_data"
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {string} tab_shown - "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsTabViewParams>} LogObject<shoutoutStatsTabViewParams>
 */
export function shoutoutStatsTabView(params) {
    return { evid: 313, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsHeaderCtaClick' event (evid: 314)
 *
 * Event description: when the user clicked on the header CTA (not upgrade!!!)
 *
 * @param {shoutoutStatsHeaderCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - "the name of the cta clicked on optional values: reuse"
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsHeaderCtaClickParams>} LogObject<shoutoutStatsHeaderCtaClickParams>
 */
export function shoutoutStatsHeaderCtaClick(params) {
    return { evid: 314, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsStatClick' event (evid: 315)
 *
 * Event description: when the user clicked on a stat in any of the tabs
 *
 * @param {shoutoutStatsStatClickParams} params - The parameters for this event
 * @property {string} stat_name - "the name of the stat the user clicked on optional values: DELIVERED/OPENED/CLICKED/UNSUBSCRIBED/BOUNCED/SPAM COMPAINTS"
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} tab_shown - "the name of the tab that the user views optional values: email stats/ email recipients/ social stats"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsStatClickParams>} LogObject<shoutoutStatsStatClickParams>
 */
export function shoutoutStatsStatClick(params) {
    return { evid: 315, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsRecipientsApplyFilter' event (evid: 316)
 *
 * Event description: when the user applays a filter to the recipients  also will be sent in the open of the tab with the filter already applyied on
 *
 * @param {shoutoutStatsRecipientsApplyFilterParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} apply_type - "how the filter was applyied, by the manual selection in the tab or automaticly by the opening source optional values: manual/automatic"
 * @property {string} filter - "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
 * @property {GUID} message_id - message id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsRecipientsApplyFilterParams>} LogObject<shoutoutStatsRecipientsApplyFilterParams>
 */
export function shoutoutStatsRecipientsApplyFilter(params) {
    return { evid: 316, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsRecipientsContactClick' event (evid: 317)
 *
 * Event description: when the user clicks on a contact for more details
 *
 * @param {shoutoutStatsRecipientsContactClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} filter - "the name of the filter, optional values: Sent/Delivered/opened/clicked/orders/not opened etc..."
 * @property {GUID} message_id - message id
 * @property {GUID} contact_id - the id of the contact
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsRecipientsContactClickParams>} LogObject<shoutoutStatsRecipientsContactClickParams>
 */
export function shoutoutStatsRecipientsContactClick(params) {
    return { evid: 317, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsShareModalView' event (evid: 318)
 *
 * Event description: when the user gets the modal to share his campaign in social media or by link
 *
 * @param {shoutoutStatsShareModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsShareModalViewParams>} LogObject<shoutoutStatsShareModalViewParams>
 */
export function shoutoutStatsShareModalView(params) {
    return { evid: 318, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsTooltipView' event (evid: 319)
 *
 * Event description: when the user views a tooltip
 *
 * @param {shoutoutStatsTooltipViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} tooltip_name - the name of the tooltip
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsTooltipViewParams>} LogObject<shoutoutStatsTooltipViewParams>
 */
export function shoutoutStatsTooltipView(params) {
    return { evid: 319, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageEmailFocus' event (evid: 32)
 *
 * Event description: shoutout send page -> email focus.
 *
 * @param {shoutoutSendPageEmailFocusParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageEmailFocusParams>} LogObject<shoutoutSendPageEmailFocusParams>
 */
export function shoutoutSendPageEmailFocus(params) {
    return { evid: 32, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsLearnMoreClick' event (evid: 320)
 *
 * Event description: when the user clickes on one of the learn more options
 *
 * @param {shoutoutStatsLearnMoreClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} link_name - the name of the link to the learn more artical
 * @property {GUID} message_id - message id
 * @property {string} page_status - "the status of the page, if empty or not optional values: empty_state/full_data"
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsLearnMoreClickParams>} LogObject<shoutoutStatsLearnMoreClickParams>
 */
export function shoutoutStatsLearnMoreClick(params) {
    return { evid: 320, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsContactPageInfoLoaded' event (evid: 321)
 *
 * Event description: after contacts page is open (event 36:20), and then load the full contacts label and filter lists this event will be fired contain all this data
 *
 * @param {shoutoutContactsContactPageInfoLoadedParams} params - The parameters for this event
 * @property {boolean} only_active - true = only actives
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} contacts_count - number of contacts loaded
 * @property {string} package_id - package_name
 * @property {number} total_segments_count - Total segments count (ready for selection and not ready for selection (procesing etc.)
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} filters_count - number of filters loaded
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} ready_segments_count - Segments, which are available for selection count
 * @property {number} labels_count - number of label loaded
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsContactPageInfoLoadedParams>} LogObject<shoutoutContactsContactPageInfoLoadedParams>
 */
export function shoutoutContactsContactPageInfoLoaded(params) {
    return { evid: 321, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeGoToTopClick' event (evid: 322)
 *
 * Event description: in composer, when user drill sown to bottom , he can click on the 'go to top' button which will  bring him to top
 *
 * @param {shoutoutComposeGoToTopClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeGoToTopClickParams>} LogObject<shoutoutComposeGoToTopClickParams>
 */
export function shoutoutComposeGoToTopClick(params) {
    return { evid: 322, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerClickOnAssistanceIcon' event (evid: 323)
 *
 * Event description: in composer click on assistance
 *
 * @param {composerClickOnAssistanceIconParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerClickOnAssistanceIconParams>} LogObject<composerClickOnAssistanceIconParams>
 */
export function composerClickOnAssistanceIcon(params) {
    return { evid: 323, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistancePopoverClose' event (evid: 324)
 *
 * Event description: generic event for closing th epopover in any of its steps
 *
 * @param {composerAssistancePopoverCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} step - welcome, tasts list, success
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} number_of_tasks - number of open tasks - if exists
 * @property {GUID} message_id - if exists
 * @property {string} origin - the triggered for close  - on stage, icon click, x click
 * @property {string} tasks_list - json with all tasks types with rule id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistancePopoverCloseParams>} LogObject<composerAssistancePopoverCloseParams>
 */
export function composerAssistancePopoverClose(params) {
    return { evid: 324, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceWelcomePopoverView' event (evid: 325)
 *
 * Event description: welcome assistance popover is opened
 *
 * @param {composerAssistanceWelcomePopoverViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceWelcomePopoverViewParams>} LogObject<composerAssistanceWelcomePopoverViewParams>
 */
export function composerAssistanceWelcomePopoverView(params) {
    return { evid: 325, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceWelcomePopoverCtaClick' event (evid: 326)
 *
 * Event description: welcome assistance popover is opened, clicl on the cta to start
 *
 * @param {composerAssistanceWelcomePopoverCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cta name - lets go
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceWelcomePopoverCtaClickParams>} LogObject<composerAssistanceWelcomePopoverCtaClickParams>
 */
export function composerAssistanceWelcomePopoverCtaClick(params) {
    return { evid: 326, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistancePopoverTasksListView' event (evid: 327)
 *
 * Event description: the assistance popover is open
 *
 * @param {composerAssistancePopoverTasksListViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} number_of_tasks - number of open tasks
 * @property {GUID} message_id - if exists
 * @property {string} tasks_list - json with all tasks types with rule id
 * @property {GUID} msid - msid
 * @property {string} default_task - the default task expended when opening the list
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistancePopoverTasksListViewParams>} LogObject<composerAssistancePopoverTasksListViewParams>
 */
export function composerAssistancePopoverTasksListView(params) {
    return { evid: 327, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceExpendTask' event (evid: 328)
 *
 * Event description: in the assistance popover click on one of the tasks to expend it
 *
 * @param {composerAssistanceExpendTaskParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} task_type - text, button, link, social....
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} rule - unique rule id
 * @property {GUID} message_id - if exists
 * @property {string} origin - user, auto
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceExpendTaskParams>} LogObject<composerAssistanceExpendTaskParams>
 */
export function composerAssistanceExpendTask(params) {
    return { evid: 328, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceTaskComplete' event (evid: 329)
 *
 * Event description: user completed a task and it marked as completed
 *
 * @param {composerAssistanceTaskCompleteParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} task_type - text, button, link, social....
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} rule - unique rule id
 * @property {GUID} message_id - if exists
 * @property {string} assist_stat - open/closed
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceTaskCompleteParams>} LogObject<composerAssistanceTaskCompleteParams>
 */
export function composerAssistanceTaskComplete(params) {
    return { evid: 329, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageSendButton' event (evid: 33)
 *
 * Event description: shoutout send page -> send button.
 *
 * @param {shoutoutSendPageSendButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} count - count
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageSendButtonParams>} LogObject<shoutoutSendPageSendButtonParams>
 */
export function shoutoutSendPageSendButton(params) {
    return { evid: 33, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceTaskCtaClick' event (evid: 330)
 *
 * Event description: user click on a task cta
 *
 * @param {composerAssistanceTaskCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} task_type - text, button, link, social....
 * @property {string} cta_type - apply, dismiss, upgrade, not now
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} rule - unique rule id
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceTaskCtaClickParams>} LogObject<composerAssistanceTaskCtaClickParams>
 */
export function composerAssistanceTaskCtaClick(params) {
    return { evid: 330, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceCompleteAllTasksSucessView' event (evid: 331)
 *
 * Event description: user completed all tasks and got the succedss view
 *
 * @param {composerAssistanceCompleteAllTasksSucessViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceCompleteAllTasksSucessViewParams>} LogObject<composerAssistanceCompleteAllTasksSucessViewParams>
 */
export function composerAssistanceCompleteAllTasksSucessView(params) {
    return { evid: 331, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'composerAssistanceCompleteAllTasksSucessDoneClick' event (evid: 332)
 *
 * Event description: user completed all tasks and got the success view - click on got it cta
 *
 * @param {composerAssistanceCompleteAllTasksSucessDoneClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cta name
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - if exists
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<composerAssistanceCompleteAllTasksSucessDoneClickParams>} LogObject<composerAssistanceCompleteAllTasksSucessDoneClickParams>
 */
export function composerAssistanceCompleteAllTasksSucessDoneClick(params) {
    return { evid: 332, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeOnStageItemCropClick' event (evid: 334)
 *
 * Event description: on stage, click on crop action on an item, and actually changed the value
 *
 * @param {shoutoutComposeOnStageItemCropClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} type - itme type
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeOnStageItemCropClickParams>} LogObject<shoutoutComposeOnStageItemCropClickParams>
 */
export function shoutoutComposeOnStageItemCropClick(params) {
    return { evid: 334, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emWebComposerComponentInfoTooltipView' event (evid: 335)
 *
 * Event description: when a user hover on the info tooltip
 *
 * @param {emWebComposerComponentInfoTooltipViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} component_name - image/columns/social....
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} is_first - true if it's the first time the user opens the composer
 * @property {GUID} msid - msid
 * @return {LogObject<emWebComposerComponentInfoTooltipViewParams>} LogObject<emWebComposerComponentInfoTooltipViewParams>
 */
export function emWebComposerComponentInfoTooltipView(params) {
    return { evid: 335, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMessageView' event (evid: 336)
 *
 * Event description: Generic event for message view from any page in shoutout
 *
 * @param {shoutoutMessageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - the page where the message is shown (dashboard, composer..))
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message_name - unique name of the message
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMessageViewParams>} LogObject<shoutoutMessageViewParams>
 */
export function shoutoutMessageView(params) {
    return { evid: 336, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMessageClick' event (evid: 337)
 *
 * Event description: Generic event for message click from any page in shoutout
 *
 * @param {shoutoutMessageClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - name of the button clicked (dismiss/go to automations..))
 * @property {string} page - the page where the message is shown (dashboard, composer..))
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message_name - unique name of the message
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMessageClickParams>} LogObject<shoutoutMessageClickParams>
 */
export function shoutoutMessageClick(params) {
    return { evid: 337, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerDynamicVariableModalView' event (evid: 338)
 *
 * Event description: dynamic variable modal view open
 *
 * @param {teComposerDynamicVariableModalViewParams} params - The parameters for this event
 * @property {string} modal_type - type of the modal(e.g Subject and preview)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teComposerDynamicVariableModalViewParams>} LogObject<teComposerDynamicVariableModalViewParams>
 */
export function teComposerDynamicVariableModalView(params) {
    return { evid: 338, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerDynamicVariableModalCta' event (evid: 339)
 *
 * Event description: dynamic variable modal view click
 *
 * @param {teComposerDynamicVariableModalCtaParams} params - The parameters for this event
 * @property {string} modal_type - type of the modal(e.g Subject and preview)
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cta name (e.g save)
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teComposerDynamicVariableModalCtaParams>} LogObject<teComposerDynamicVariableModalCtaParams>
 */
export function teComposerDynamicVariableModalCta(params) {
    return { evid: 339, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageSubjectFocus' event (evid: 34)
 *
 * Event description: shoutout send page -> subject focus.
 *
 * @param {shoutoutSendPageSubjectFocusParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSendPageSubjectFocusParams>} LogObject<shoutoutSendPageSubjectFocusParams>
 */
export function shoutoutSendPageSubjectFocus(params) {
    return { evid: 34, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerAddDynamicVariable' event (evid: 340)
 *
 * Event description: add dynamic variable
 *
 * @param {teComposerAddDynamicVariableParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} variable_added - variable added(sites_name...))
 * @property {string} type - Subject and preview
 * @property {GUID} msid - msid
 * @property {string} component - Subject line/preview text
 * @property {string} template_id - template id
 * @return {LogObject<teComposerAddDynamicVariableParams>} LogObject<teComposerAddDynamicVariableParams>
 */
export function teComposerAddDynamicVariable(params) {
    return { evid: 340, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerModalView' event (evid: 341)
 *
 * Event description: generic modal view in the composer
 *
 * @param {teComposerModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} modal_name - name of the modal(example: Reset template)
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teComposerModalViewParams>} LogObject<teComposerModalViewParams>
 */
export function teComposerModalView(params) {
    return { evid: 341, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerModalClick' event (evid: 342)
 *
 * Event description: generic modal click in the composer
 *
 * @param {teComposerModalClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - reset/cancel/dismiss
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} modal_name - name of the modal(example: Reset template)
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teComposerModalClickParams>} LogObject<teComposerModalClickParams>
 */
export function teComposerModalClick(params) {
    return { evid: 342, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teNotificationView' event (evid: 343)
 *
 * Event description: generic notificarion view in the composer
 *
 * @param {teNotificationViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} notification_name - name of the notification
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teNotificationViewParams>} LogObject<teNotificationViewParams>
 */
export function teNotificationView(params) {
    return { evid: 343, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teResetTemplateClick' event (evid: 344)
 *
 * Event description: reset template click
 *
 * @param {teResetTemplateClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teResetTemplateClickParams>} LogObject<teResetTemplateClickParams>
 */
export function teResetTemplateClick(params) {
    return { evid: 344, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeOpenDynamicVariableClick' event (evid: 345)
 *
 * Event description: when a user click on a button that will open the modal of adding a dynamic variable
 *
 * @param {shoutoutComposeOpenDynamicVariableClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} cta_source - where the user click to open the variable modal (add dynamic variable button OR existing variable)
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeOpenDynamicVariableClickParams>} LogObject<shoutoutComposeOpenDynamicVariableClickParams>
 */
export function shoutoutComposeOpenDynamicVariableClick(params) {
    return { evid: 345, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teComposerComponentCtaClick' event (evid: 346)
 *
 * Event description: when the user click on a CTA in one of the component in the composer
 *
 * @param {teComposerComponentCtaClickParams} params - The parameters for this event
 * @property {boolean} is_title - is title region
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} component_name - component name
 * @property {string} package_id - package name
 * @property {string} context - context (TE/APeS...)
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cta_type
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<teComposerComponentCtaClickParams>} LogObject<teComposerComponentCtaClickParams>
 */
export function teComposerComponentCtaClick(params) {
    return { evid: 346, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeMoveComponent' event (evid: 347)
 *
 * Event description: event triggered when user leaves the component he meant to move
 *
 * @param {shoutoutComposeMoveComponentParams} params - The parameters for this event
 * @property {boolean} is_title - is title region
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context of mail
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} move_delta - positive=up, negative=down, 0=no change
 * @property {string} move_type - move_type
 * @property {string} component_type - the type of the component moved
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeMoveComponentParams>} LogObject<shoutoutComposeMoveComponentParams>
 */
export function shoutoutComposeMoveComponent(params) {
    return { evid: 347, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardAscendQuotaWidgetLoad' event (evid: 348)
 *
 * Event description: in the email marketing dashboard - keep track of user's email quota when the widget loads
 *
 * @param {shoutoutDashboardAscendQuotaWidgetLoadParams} params - The parameters for this event
 * @property {number} campaign_quota_total - total number of campaigns in user's quota. 1,000,000 for unlimited
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} email_quota_used - number of email recipients already used from user's quota in current cycle
 * @property {number} email_quota_total - total number of email recipients in user's quota. 1,000,000 for unlimited
 * @property {number} campaign_quota_used - number of campaigns already used from user's quota in current cycle
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardAscendQuotaWidgetLoadParams>} LogObject<shoutoutDashboardAscendQuotaWidgetLoadParams>
 */
export function shoutoutDashboardAscendQuotaWidgetLoad(params) {
    return { evid: 348, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposerSwitchTabs' event (evid: 349)
 *
 * Event description: when the user switches between the Content and the Design tabs of an element in the composer
 *
 * @param {shoutoutComposerSwitchTabsParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} tab - tab
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} itemType - item type  - text, button, link, background, inner background
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposerSwitchTabsParams>} LogObject<shoutoutComposerSwitchTabsParams>
 */
export function shoutoutComposerSwitchTabs(params) {
    return { evid: 349, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSelectCancelClick' event (evid: 35)
 *
 * Event description: SO_SELECT_CANCEL_CLICK
 *
 * @param {shoutoutSelectCancelClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSelectCancelClickParams>} LogObject<shoutoutSelectCancelClickParams>
 */
export function shoutoutSelectCancelClick(params) {
    return { evid: 35, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeInitiateShoutoutTemplateFromBmIntegration' event (evid: 350)
 *
 * Event description: When shoutout composer is called via template selection from a BM integration by another vertical
 *
 * @param {shoutoutComposeInitiateShoutoutTemplateFromBmIntegrationParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - source from where the users open the composer
 * @property {string} message_id - message_id
 * @property {string} integrationType - example: use-template/selected-contacts/batch/undefined
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @property {string} metadata - metadata
 * @return {LogObject<shoutoutComposeInitiateShoutoutTemplateFromBmIntegrationParams>} LogObject<shoutoutComposeInitiateShoutoutTemplateFromBmIntegrationParams>
 */
export function shoutoutComposeInitiateShoutoutTemplateFromBmIntegration(params) {
    return { evid: 350, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardCardLoadedWithStats' event (evid: 351)
 *
 * Event description: when a card showing details of a sent message with stats is presented to the user. Note that this event will fire when we load the card, even if the stats themselves do not load.
 *
 * @param {shoutoutDashboardCardLoadedWithStatsParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} message_type - published or sent
 * @property {string} ml_translation_language - ml_translation_language
 * @property {DateTime} published_on_date - timestamp on which message was published
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<shoutoutDashboardCardLoadedWithStatsParams>} LogObject<shoutoutDashboardCardLoadedWithStatsParams>
 */
export function shoutoutDashboardCardLoadedWithStats(params) {
    return { evid: 351, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardCloseTheLoopStatsLoaded' event (evid: 352)
 *
 * Event description: when campaign's close the loop stats are loaded on a campaign card. Note that in the case of no data (0 orders, 0 revenue or 0 unique visitors this event will not be fired)
 *
 * @param {shoutoutDashboardCloseTheLoopStatsLoadedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - ascend package name
 * @property {string} context - context
 * @property {GUID} uuid - user_id
 * @property {string} page - which page stats were loaded in (dashboard / my campaigns / stats)
 * @property {string} package_group - ascend package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} card_values - json, (e.g. Orders:number of orders, revenue:amount of revenue, bookings:number of bookings etc.)
 * @property {DateTime} published_on_date - timestamp on which message was published
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @property {string} template_id - template_id
 * @return {LogObject<shoutoutDashboardCloseTheLoopStatsLoadedParams>} LogObject<shoutoutDashboardCloseTheLoopStatsLoadedParams>
 */
export function shoutoutDashboardCloseTheLoopStatsLoaded(params) {
    return { evid: 352, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPanelDropdownClick' event (evid: 353)
 *
 * Event description: When a drop down menu is expanded or collapsed
 *
 * @param {shoutoutPanelDropdownClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - ascend package name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - ascend package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} clickType - expand / collapse
 * @property {GUID} msid - msid
 * @property {string} item - item for which the drop down menu was clicked (font, format, size etc.)
 * @return {LogObject<shoutoutPanelDropdownClickParams>} LogObject<shoutoutPanelDropdownClickParams>
 */
export function shoutoutPanelDropdownClick(params) {
    return { evid: 353, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposerExitCta' event (evid: 356)
 *
 * Event description: When the user clicks back out of composer
 *
 * @param {shoutoutComposerExitCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button_name
 * @property {string} exitType - where the user is exiting to
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposerExitCtaParams>} LogObject<shoutoutComposerExitCtaParams>
 */
export function shoutoutComposerExitCta(params) {
    return { evid: 356, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutResendIconTooltipShow' event (evid: 357)
 *
 * Event description: when user hovers over greyed out resend icon on the campaign card
 *
 * @param {shoutoutResendIconTooltipShowParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message - tooltip message
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutResendIconTooltipShowParams>} LogObject<shoutoutResendIconTooltipShowParams>
 */
export function shoutoutResendIconTooltipShow(params) {
    return { evid: 357, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutContactsAddSegmentsClick' event (evid: 358)
 *
 * Event description: When user clicks on add segments in contact selection screen
 *
 * @param {shoutoutContactsAddSegmentsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} has_segments - does user have segments
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutContactsAddSegmentsClickParams>} LogObject<shoutoutContactsAddSegmentsClickParams>
 */
export function shoutoutContactsAddSegmentsClick(params) {
    return { evid: 358, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutStatsReportsCta' event (evid: 359)
 *
 * Event description: When user clicks on link in email marketing stats page, which leads to analytics reports
 *
 * @param {shoutoutStatsReportsCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - what was clicked (expand / report name)
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutStatsReportsCtaParams>} LogObject<shoutoutStatsReportsCtaParams>
 */
export function shoutoutStatsReportsCta(params) {
    return { evid: 359, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSelectUseThisClick' event (evid: 36)
 *
 * Event description: SO_SELECT_USE_THIS_CLICK
 *
 * @param {shoutoutSelectUseThisClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSelectUseThisClickParams>} LogObject<shoutoutSelectUseThisClickParams>
 */
export function shoutoutSelectUseThisClick(params) {
    return { evid: 36, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEligibilityForFirstTimeExp' event (evid: 360)
 *
 * Event description: When user opens shoutout dashboard while being eligible for first time experience
 *
 * @param {shoutoutEligibilityForFirstTimeExpParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} experience - which first time experience user is eligible for
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEligibilityForFirstTimeExpParams>} LogObject<shoutoutEligibilityForFirstTimeExpParams>
 */
export function shoutoutEligibilityForFirstTimeExp(params) {
    return { evid: 360, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'domainAuthenticationCtaClick' event (evid: 361)
 *
 * Event description: When user clicks on one of the CTAs associated with domain authentication
 *
 * @param {domainAuthenticationCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - view_dns_records, authenticate, close, done, need_guidance, learn_why, copy_host/points_cnameX
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} domain_authentication_status - authenticated / not authenticated
 * @property {GUID} msid - msid
 * @return {LogObject<domainAuthenticationCtaClickParams>} LogObject<domainAuthenticationCtaClickParams>
 */
export function domainAuthenticationCtaClick(params) {
    return { evid: 361, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'senderDetailsWidgetView' event (evid: 362)
 *
 * Event description: when user views sender details widget
 *
 * @param {senderDetailsWidgetViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} domainmanagementstatus - public / private / managed
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} from_name - from_name
 * @property {string} domain_authentication_status - authenticated / not authenticated
 * @property {string} sender_details_status - verified / unverified
 * @property {string} reply_to_name - reply_to_name
 * @property {GUID} msid - msid
 * @return {LogObject<senderDetailsWidgetViewParams>} LogObject<senderDetailsWidgetViewParams>
 */
export function senderDetailsWidgetView(params) {
    return { evid: 362, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'domainAuthenticationModalView' event (evid: 363)
 *
 * Event description: When user views domain authentication modal
 *
 * @param {domainAuthenticationModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} loadStatus - success / fail
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} domain_authentication_status - authenticated / not authenticated
 * @property {GUID} msid - msid
 * @return {LogObject<domainAuthenticationModalViewParams>} LogObject<domainAuthenticationModalViewParams>
 */
export function domainAuthenticationModalView(params) {
    return { evid: 363, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutAscendPopoverView' event (evid: 364)
 *
 * Event description: When user hovers over Ascend upgrade button and sees Ascend popover
 *
 * @param {shoutoutAscendPopoverViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context - TE
 * @property {GUID} uuid - uuid
 * @property {string} page - page, in which the popover was viewed
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutAscendPopoverViewParams>} LogObject<shoutoutAscendPopoverViewParams>
 */
export function shoutoutAscendPopoverView(params) {
    return { evid: 364, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutRenameModalCta' event (evid: 365)
 *
 * Event description: when user clicks within rename campaign modal
 *
 * @param {shoutoutRenameModalCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - send, pause, cancel
 * @property {string} page - page in which the modal was clicked
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutRenameModalCtaParams>} LogObject<shoutoutRenameModalCtaParams>
 */
export function shoutoutRenameModalCta(params) {
    return { evid: 365, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutCampaignThreeDotsClick' event (evid: 366)
 *
 * Event description: when user clicks on three dots either on campaign card or in stats page
 *
 * @param {shoutoutCampaignThreeDotsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard / my_campaigns / campaign_stats
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutCampaignThreeDotsClickParams>} LogObject<shoutoutCampaignThreeDotsClickParams>
 */
export function shoutoutCampaignThreeDotsClick(params) {
    return { evid: 366, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutCampaignNameChanged' event (evid: 367)
 *
 * Event description: when user changes campaign name
 *
 * @param {shoutoutCampaignNameChangedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} page - dashboard / my_campaigns / campaign_stats
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} new_name - new name of the campaign
 * @property {string} old_name - old name of the campaign
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutCampaignNameChangedParams>} LogObject<shoutoutCampaignNameChangedParams>
 */
export function shoutoutCampaignNameChanged(params) {
    return { evid: 367, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeThemeSelect' event (evid: 368)
 *
 * Event description: when user selects a new theme
 *
 * @param {shoutoutComposeThemeSelectParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} theme_selected - name of hte
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeThemeSelectParams>} LogObject<shoutoutComposeThemeSelectParams>
 */
export function shoutoutComposeThemeSelect(params) {
    return { evid: 368, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutLinkComponentInfo' event (evid: 369)
 *
 * Event description: when the user clicks on "apply" after adding link component
 *
 * @param {shoutoutLinkComponentInfoParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} source - wix / embedly
 * @property {string} package_id - package_name
 * @property {string} url - url
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message id
 * @property {boolean} is_successful - true / false
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutLinkComponentInfoParams>} LogObject<shoutoutLinkComponentInfoParams>
 */
export function shoutoutLinkComponentInfo(params) {
    return { evid: 369, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizePageView' event (evid: 37)
 *
 * Event description: ST_CUSTOMIZE_PAGE_VIEW
 *
 * @param {smartTriggersCustomizePageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizePageViewParams>} LogObject<smartTriggersCustomizePageViewParams>
 */
export function smartTriggersCustomizePageView(params) {
    return { evid: 37, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutQuotaChangeModalView' event (evid: 370)
 *
 * Event description: when user sees quota change modal
 *
 * @param {shoutoutQuotaChangeModalViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutQuotaChangeModalViewParams>} LogObject<shoutoutQuotaChangeModalViewParams>
 */
export function shoutoutQuotaChangeModalView(params) {
    return { evid: 370, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutQuotaChangeModalCta' event (evid: 371)
 *
 * Event description: when user clicks on one of the CTAs in quota change modal
 *
 * @param {shoutoutQuotaChangeModalCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - cta
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutQuotaChangeModalCtaParams>} LogObject<shoutoutQuotaChangeModalCtaParams>
 */
export function shoutoutQuotaChangeModalCta(params) {
    return { evid: 371, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSendToUnsubscribedCheckboxCta' event (evid: 372)
 *
 * Event description: When a user checks or unchecks the checkbox for sending automated email to unsubscribed users
 *
 * @param {teSendToUnsubscribedCheckboxCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} cta_type - check / uncheck
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSendToUnsubscribedCheckboxCtaParams>} LogObject<teSendToUnsubscribedCheckboxCtaParams>
 */
export function teSendToUnsubscribedCheckboxCta(params) {
    return { evid: 372, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'teSendToUnsubscribedLearnMoreCta' event (evid: 373)
 *
 * Event description: When a user clicks on kb link about 'send to unsubscribed'
 *
 * @param {teSendToUnsubscribedLearnMoreCtaParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<teSendToUnsubscribedLearnMoreCtaParams>} LogObject<teSendToUnsubscribedLearnMoreCtaParams>
 */
export function teSendToUnsubscribedLearnMoreCta(params) {
    return { evid: 373, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'htmlComponentSanitization' event (evid: 374)
 *
 * Event description: Event fires on html component sanitization (Click on 'Apply')
 *
 * @param {htmlComponentSanitizationParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - EM context
 * @property {GUID} uuid - uuid
 * @property {string} invalid_tags - All invalid html syntax tags
 * @property {string} invalid_attributes - All invalid html syntax attributes
 * @property {string} package_group - EM package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} all_attributes - All html syntax attributes
 * @property {string} warning_msg - warning message context
 * @property {GUID} msid - msid
 * @property {string} all_tags - All html syntax tags
 * @return {LogObject<htmlComponentSanitizationParams>} LogObject<htmlComponentSanitizationParams>
 */
export function htmlComponentSanitization(params) {
    return { evid: 374, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'htmlComponentCodePasted' event (evid: 375)
 *
 * Event description: HTML component code batch pasted
 *
 * @param {htmlComponentCodePastedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} char_diff - Pasted char count
 * @property {GUID} msid - msid
 * @return {LogObject<htmlComponentCodePastedParams>} LogObject<htmlComponentCodePastedParams>
 */
export function htmlComponentCodePasted(params) {
    return { evid: 375, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPremiumProductModalShown' event (evid: 376)
 *
 * Event description: Event for EM premium product modal shown (Paywall)
 *
 * @param {emPremiumProductModalShownParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - EM package ID
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - EM package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} modal_name - Reason why the modal was shown
 * @property {string} origin - Page on which the event fires
 * @property {GUID} msid - msid
 * @return {LogObject<emPremiumProductModalShownParams>} LogObject<emPremiumProductModalShownParams>
 */
export function emPremiumProductModalShown(params) {
    return { evid: 376, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPremiumProductUpgradeComparePlansClick' event (evid: 377)
 *
 * Event description: Event for upgrade button click
 *
 * @param {emPremiumProductUpgradeComparePlansClickParams} params - The parameters for this event
 * @property {string} cycle_name - name of the current user EM premium cycle
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - EM package ID
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - EM package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - upgrade/compare_plans/CTA_upgrade
 * @property {string} origin - Page on which the event fires
 * @property {GUID} msid - msid
 * @property {string} button_location - Where the button is in the page
 * @return {LogObject<emPremiumProductUpgradeComparePlansClickParams>} LogObject<emPremiumProductUpgradeComparePlansClickParams>
 */
export function emPremiumProductUpgradeComparePlansClick(params) {
    return { evid: 377, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPremiumProductUpgradeButtonHover' event (evid: 378)
 *
 * Event description: Event fires on upgrade button hover
 *
 * @param {emPremiumProductUpgradeButtonHoverParams} params - The parameters for this event
 * @property {string} cycle_name - name of the current user EM premium cycle
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - EM package ID
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - EM package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - Page on which the event fires
 * @property {GUID} msid - msid
 * @property {string} button_location - Where the button is in the page
 * @return {LogObject<emPremiumProductUpgradeButtonHoverParams>} LogObject<emPremiumProductUpgradeButtonHoverParams>
 */
export function emPremiumProductUpgradeButtonHover(params) {
    return { evid: 378, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emOpenPackagePicker' event (evid: 379)
 *
 * Event description: EM Standalone Premium Plans Package Picked Opened (page shown)
 *
 * @param {emOpenPackagePickerParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button name that lead to PP (source comes from 36:377)
 * @property {string} origin - where the page was opened from (source comes from 36:377)
 * @property {GUID} msid - msid
 * @property {string} em_premium_status - current EM premium package + cycle
 * @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
 * @property {boolean} is_sale - Flag that defines if the users PP is with a sale
 * @return {LogObject<emOpenPackagePickerParams>} LogObject<emOpenPackagePickerParams>
 */
export function emOpenPackagePicker(params) {
    return { evid: 379, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizeNextClick' event (evid: 38)
 *
 * Event description: ST_CUSTOMIZE_NEXT_CLICK
 *
 * @param {smartTriggersCustomizeNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizeNextClickParams>} LogObject<smartTriggersCustomizeNextClickParams>
 */
export function smartTriggersCustomizeNextClick(params) {
    return { evid: 38, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPackagePickerCyclePage' event (evid: 380)
 *
 * Event description: EM Package Picker Cycle Page Opened (page shown)
 *
 * @param {emPackagePickerCyclePageParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button name that lead to PP (source comes from 36:377)
 * @property {string} package_name - selected EM package name
 * @property {string} origin - where the page was opened from (source comes from 36:377)
 * @property {GUID} msid - msid
 * @property {string} em_premium_status - current EM premium package + cycle
 * @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
 * @property {boolean} is_sale - Flag that defines if the users PP is with a sale
 * @return {LogObject<emPackagePickerCyclePageParams>} LogObject<emPackagePickerCyclePageParams>
 */
export function emPackagePickerCyclePage(params) {
    return { evid: 380, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPackagePickerCheckoutPage' event (evid: 381)
 *
 * Event description: EM  Package Picker Checkout Page Opened (page shown)
 *
 * @param {emPackagePickerCheckoutPageParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button name that lead to PP (source comes from 36:377)
 * @property {string} package_name - selected EM package name
 * @property {string} origin - where the page was opened from (source comes from 36:377)
 * @property {string} cycleName - selected EM premium package cycle
 * @property {GUID} msid - msid
 * @property {string} em_premium_status - current EM premium package + cycle
 * @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
 * @property {boolean} is_sale - Flag that defines if the users PP is with a sale
 * @return {LogObject<emPackagePickerCheckoutPageParams>} LogObject<emPackagePickerCheckoutPageParams>
 */
export function emPackagePickerCheckoutPage(params) {
    return { evid: 381, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPurchasePremiumPlan' event (evid: 382)
 *
 * Event description: EM Premium Plan Purchased (Thank you page shown)
 *
 * @param {emPurchasePremiumPlanParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button name that lead to PP (source comes from 36:377)
 * @property {string} package_name - selected EM package name
 * @property {string} origin - where the page was opened from (source comes from 36:377)
 * @property {string} cycleName - selected EM premium package cycle
 * @property {boolean} is_mailbox_promo - true if user was shown the mailbox promo
 * @property {GUID} msid - msid
 * @property {string} em_premium_status - current EM premium package + cycle
 * @property {string} button_location - where was the button that lead to PP (source comes from 36:377)
 * @property {boolean} is_sale - Flag that defines if the users PP is with a sale
 * @return {LogObject<emPurchasePremiumPlanParams>} LogObject<emPurchasePremiumPlanParams>
 */
export function emPurchasePremiumPlan(params) {
    return { evid: 382, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPackagePickerCtaClick' event (evid: 383)
 *
 * Event description: any link or button click in EM premium package picker
 *
 * @param {emPackagePickerCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {Url} url - url of the button/link
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - button/link name (translation_key)
 * @property {string} origin - name of the page
 * @property {boolean} is_primary_cta - true if click is for the main flow
 * @property {GUID} msid - msid
 * @return {LogObject<emPackagePickerCtaClickParams>} LogObject<emPackagePickerCtaClickParams>
 */
export function emPackagePickerCtaClick(params) {
    return { evid: 383, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emPackagePickerFaqClick' event (evid: 384)
 *
 * Event description: EM Premium Package Picker FAQ accordion click
 *
 * @param {emPackagePickerFaqClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - name of the FAQ article (translation_key)
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<emPackagePickerFaqClickParams>} LogObject<emPackagePickerFaqClickParams>
 */
export function emPackagePickerFaqClick(params) {
    return { evid: 384, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeToggleClick' event (evid: 385)
 *
 * Event description: Event for Toggling settings in shoutout composer
 *
 * @param {shoutoutComposeToggleClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {boolean} toggleState - toggle value (true, false)
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} toggle_name - name of the setting being toggled
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeToggleClickParams>} LogObject<shoutoutComposeToggleClickParams>
 */
export function shoutoutComposeToggleClick(params) {
    return { evid: 385, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emailsButtonClick' event (evid: 386)
 *
 * Event description: Generic button click event
 *
 * @param {emailsButtonClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} button_name - name of the button
 * @property {string} origin - where the button was clicked
 * @property {GUID} msid - msid
 * @return {LogObject<emailsButtonClickParams>} LogObject<emailsButtonClickParams>
 */
export function emailsButtonClick(params) {
    return { evid: 386, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emComposerRegionSettingChanged' event (evid: 387)
 *
 * Event description: Any of the EM Composer regions' settings changed
 *
 * @param {emComposerRegionSettingChangedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} settings_subtab - name of the settings subtab
 * @property {string} settings_tab - name of the settings tab
 * @property {string} region_type - name of the region type, same as 36:12
 * @property {string} region_subtype - name of the region sub type, same as 36:12
 * @property {string} setting_name - name of the setting that is being interacted with
 * @property {string} setting_value - value of the setting that is being interacted with
 * @property {GUID} msid - msid
 * @return {LogObject<emComposerRegionSettingChangedParams>} LogObject<emComposerRegionSettingChangedParams>
 */
export function emComposerRegionSettingChanged(params) {
    return { evid: 387, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emComposerUndoRedoActions' event (evid: 388)
 *
 * Event description: Event for any Undo/Redo action in the Email Marketing Composer
 *
 * @param {emComposerUndoRedoActionsParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - Sometimes can be null if the user completes actions and undoes/redoes them faster than we can save the message_id
 * @property {GUID} msid - msid
 * @property {string} action - Undo/Redo
 * @return {LogObject<emComposerUndoRedoActionsParams>} LogObject<emComposerUndoRedoActionsParams>
 */
export function emComposerUndoRedoActions(params) {
    return { evid: 388, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizeEditClick' event (evid: 39)
 *
 * Event description: ST_CUSTOMIZE_EDIT_CLICK
 *
 * @param {smartTriggersCustomizeEditClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} location - heading/hover/button
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizeEditClickParams>} LogObject<smartTriggersCustomizeEditClickParams>
 */
export function smartTriggersCustomizeEditClick(params) {
    return { evid: 39, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAutomationsWizEmailSubscriptionsStatusEmailType' event (evid: 390)
 *
 * Event description: Change in Subscription/Email status for regular users and dev mode (TPAs)
 *
 * @param {emAutomationsWizEmailSubscriptionsStatusEmailTypeParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - automation action_id
 * @property {string} state - state of the status selected
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - automation rule_id
 * @property {boolean} is_dev_mode - true/false if the action is done in dev_mode
 * @property {GUID} msid - msid
 * @return {LogObject<emAutomationsWizEmailSubscriptionsStatusEmailTypeParams>} LogObject<emAutomationsWizEmailSubscriptionsStatusEmailTypeParams>
 */
export function emAutomationsWizEmailSubscriptionsStatusEmailType(params) {
    return { evid: 390, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAuotmationsWizRecipientsAdded' event (evid: 391)
 *
 * Event description: Recipients selection in EM Wix in Automation settings (dev mode/regular users)
 *
 * @param {emAuotmationsWizRecipientsAddedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} count - count of recipients selected
 * @property {string} package_id - package_name
 * @property {GUID} action_id - automation action_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - automation rule_id
 * @property {boolean} is_dev_mode - true/false if the action is done in dev_mode
 * @property {string} recipient_type - name of the recipient selection
 * @property {string} recipient_id - id for recipient selection
 * @property {GUID} msid - msid
 * @property {string} action - add/remove
 * @return {LogObject<emAuotmationsWizRecipientsAddedParams>} LogObject<emAuotmationsWizRecipientsAddedParams>
 */
export function emAuotmationsWizRecipientsAdded(params) {
    return { evid: 391, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAuotmationsWizNotificationTopicSelected' event (evid: 392)
 *
 * Event description: Notification topic selected in EM Wiz in Automations settings (dev_mode/regular users)
 *
 * @param {emAuotmationsWizNotificationTopicSelectedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} action_id - automation action_id
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} rule_id - automation rule_id
 * @property {string} subscription_topic_name - name of the subscription topic
 * @property {boolean} is_dev_mode - true/false if the action is done in dev_mode
 * @property {GUID} subscription_topic_id - id for subscription topic
 * @property {GUID} msid - msid
 * @return {LogObject<emAuotmationsWizNotificationTopicSelectedParams>} LogObject<emAuotmationsWizNotificationTopicSelectedParams>
 */
export function emAuotmationsWizNotificationTopicSelected(params) {
    return { evid: 392, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAuotmationsWizEmailActionConfigState' event (evid: 393)
 *
 * Event description: State of full action config of the EM Wiz notification settings. Fires on Automation settings save.
 *
 * @param {emAuotmationsWizEmailActionConfigStateParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} segments_ids - array of all segments ids
 * @property {number} contacts_count - count of contacts selected
 * @property {string} package_id - package_name
 * @property {GUID} action_id - Automation action_id
 * @property {number} users_count - count of specific uuids selected
 * @property {number} contributors_count - count of contributors selected
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} segments_count - count of segments selected
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} trigger_contacts_excluded - true/false if trigger audience is excluded
 * @property {GUID} rule_id - Automation rule_id
 * @property {GUID} message_id - message_id for the EM action
 * @property {boolean} send_to_unsubscribed - true/false if send to unsubscribed is enabled
 * @property {boolean} is_transactional - true/false if the email is transactional
 * @property {string} labels_ids - array of all label ids
 * @property {string} contacts_ids - array of all contacts ids
 * @property {number} labels_count - count of labels selected
 * @property {boolean} excludeFromQuota - if the automation emails are excluded from EM Quota
 * @property {GUID} subscription_topic_id - subscription_topic_id
 * @property {string} user_ids - array of all specific user ids
 * @property {GUID} contact_id - contact_id for the EM action
 * @property {GUID} msid - msid
 * @property {string} contributor_ids - array of all contributor ids
 * @property {GUID} sender_details_id - id for selected sender details
 * @property {string} template_id - template_id for the EM action
 * @return {LogObject<emAuotmationsWizEmailActionConfigStateParams>} LogObject<emAuotmationsWizEmailActionConfigStateParams>
 */
export function emAuotmationsWizEmailActionConfigState(params) {
    return { evid: 393, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emOpenEmAiPanelModal' event (evid: 394)
 *
 * Event description: Open AI Email Generation Panel/Modal in Email Marketing
 *
 * @param {emOpenEmAiPanelModalParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - where ai panel was opened
 * @property {GUID} msid - msid
 * @return {LogObject<emOpenEmAiPanelModalParams>} LogObject<emOpenEmAiPanelModalParams>
 */
export function emOpenEmAiPanelModal(params) {
    return { evid: 394, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAiEmailGenerateTextClick' event (evid: 395)
 *
 * Event description: Click Generate in EM AI Modal/Panel (Text Region and Full Email)
 *
 * @param {emAiEmailGenerateTextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} query - User input / prompt name + version
 * @property {string} origin - Where "Generate email" was clicked from
 * @property {GUID} msid - msid
 * @return {LogObject<emAiEmailGenerateTextClickParams>} LogObject<emAiEmailGenerateTextClickParams>
 */
export function emAiEmailGenerateTextClick(params) {
    return { evid: 395, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAiModalAction' event (evid: 396)
 *
 * Event description: Actions done in EM AI Email generation modal
 *
 * @param {emAiModalActionParams} params - The parameters for this event
 * @property {string} step_name - 1, 2, 3
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} action_name - action_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} setting_name - setting_name or "CTA"
 * @property {GUID} msid - msid
 * @return {LogObject<emAiModalActionParams>} LogObject<emAiModalActionParams>
 */
export function emAiModalAction(params) {
    return { evid: 396, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAiError' event (evid: 397)
 *
 * Event description: Error occurred in EM AI email generation flow
 *
 * @param {emAiErrorParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} error_type - error_type
 * @property {GUID} msid - msid
 * @property {string} error_name - error description
 * @return {LogObject<emAiErrorParams>} LogObject<emAiErrorParams>
 */
export function emAiError(params) {
    return { evid: 397, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposerLanguageSwitch' event (evid: 398)
 *
 * Event description: When multilingual user switches language inside the composer
 *
 * @param {shoutoutComposerLanguageSwitchParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - ascend package name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - ascend package group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposerLanguageSwitchParams>} LogObject<shoutoutComposerLanguageSwitchParams>
 */
export function shoutoutComposerLanguageSwitch(params) {
    return { evid: 398, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesUserTemplateCreationSuccess' event (evid: 399)
 *
 * Event description: When user successfully creates a template
 *
 * @param {shoutoutTemplatesUserTemplateCreationSuccessParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {GUID} parent_message_id - message id which was used to create template
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} template_id - newly created template id
 * @return {LogObject<shoutoutTemplatesUserTemplateCreationSuccessParams>} LogObject<shoutoutTemplatesUserTemplateCreationSuccessParams>
 */
export function shoutoutTemplatesUserTemplateCreationSuccess(params) {
    return { evid: 399, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emMessageShown' event (evid: 40)
 *
 * Event description: Any message/banner/CTA/pop-up related to EM shown to the user
 *
 * @param {emMessageShownParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} message_name - name of the message/banner/CTA/pop-up
 * @property {string} metadata - field for custom values in the event: Map[string:string]
 * @property {GUID} msid - msid
 * @return {LogObject<emMessageShownParams>} LogObject<emMessageShownParams>
 */
export function emMessageShown(params) {
    return { evid: 40, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emAutomationWizOpenWritersLanguageSelector' event (evid: 400)
 *
 * Event description: User clicked the "Select a Language" Option in Advanced Mode EM Automations Wizard
 *
 * @param {emAutomationWizOpenWritersLanguageSelectorParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<emAutomationWizOpenWritersLanguageSelectorParams>} LogObject<emAutomationWizOpenWritersLanguageSelectorParams>
 */
export function emAutomationWizOpenWritersLanguageSelector(params) {
    return { evid: 400, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'wixEmailsGenericCheckboxClick' event (evid: 401)
 *
 * Event description: Generic click on checkbox setting
 *
 * @param {wixEmailsGenericCheckboxClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} name - name of the checkbox
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - origin of the checkbox
 * @property {boolean} checkbox_state - TRUE/FALSE
 * @property {GUID} msid - msid
 * @return {LogObject<wixEmailsGenericCheckboxClickParams>} LogObject<wixEmailsGenericCheckboxClickParams>
 */
export function wixEmailsGenericCheckboxClick(params) {
    return { evid: 401, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPackagePickerPageView' event (evid: 41)
 *
 * Event description: shoutout package picker -> page view.
 *
 * @param {shoutoutPackagePickerPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - referral_info
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPackagePickerPageViewParams>} LogObject<shoutoutPackagePickerPageViewParams>
 */
export function shoutoutPackagePickerPageView(params) {
    return { evid: 41, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPackagePickerBuyNow' event (evid: 42)
 *
 * Event description: shoutout package picker -> buy now.
 *
 * @param {shoutoutPackagePickerBuyNowParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPackagePickerBuyNowParams>} LogObject<shoutoutPackagePickerBuyNowParams>
 */
export function shoutoutPackagePickerBuyNow(params) {
    return { evid: 42, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizeTestMailClick' event (evid: 43)
 *
 * Event description: ST_CUSTOMIZE_TEST_EMAIL_CLICK
 *
 * @param {smartTriggersCustomizeTestMailClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizeTestMailClickParams>} LogObject<smartTriggersCustomizeTestMailClickParams>
 */
export function smartTriggersCustomizeTestMailClick(params) {
    return { evid: 43, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutClickOnUpgrade' event (evid: 47)
 *
 * Event description: shoutout -> click on upgrade.
 *
 * @param {shoutoutClickOnUpgradeParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} quota_type - quota_type
 * @property {string} promotion_type -  promotion type from which the click was fired. replacing origin
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} page_name - page_name
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<shoutoutClickOnUpgradeParams>} LogObject<shoutoutClickOnUpgradeParams>
 */
export function shoutoutClickOnUpgrade(params) {
    return { evid: 47, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizeChooseClick' event (evid: 48)
 *
 * Event description: ST_CUSTOMIZE_CHOOSE_CLICK
 *
 * @param {smartTriggersCustomizeChooseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizeChooseClickParams>} LogObject<smartTriggersCustomizeChooseClickParams>
 */
export function smartTriggersCustomizeChooseClick(params) {
    return { evid: 48, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'smartTriggersCustomizePreviewClick' event (evid: 49)
 *
 * Event description: ST_CUSTOMIZE_PREVIEW_CLICK
 *
 * @param {smartTriggersCustomizePreviewClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} location - hover/button
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<smartTriggersCustomizePreviewClickParams>} LogObject<smartTriggersCustomizePreviewClickParams>
 */
export function smartTriggersCustomizePreviewClick(params) {
    return { evid: 49, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSendPageMessageSent' event (evid: 50)
 *
 * Event description: shoutout send page -> message sent.
 *
 * @param {shoutoutSendPageMessageSentParams} params - The parameters for this event
 * @property {boolean} only_active - true = only actives
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {DateTime} quota_period_start - the date the quota period start
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id
 * @property {string} template_list_name - list name(BO) || top/bottom
 * @property {string} template_name - template name
 * @property {string} context
 * @property {GUID} uuid
 * @property {DateTime} set_time - the time the shoutout was set  UTC (when will it be sent)
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} additional_features - list of interesting features we want to check if users used
 * @property {string} font - title font
 * @property {GUID} message_id - guid
 * @property {string} schedule_type - "regular-send-now" / "scheduled" / "scheduled-send-now"
 * @property {number} update_quota - the new quota for the user (for unlimited value is 99999)
 * @property {string} region_types - region_types / not sent in the case of resend
 * @property {number} hour_difference - the time difference of the user time zone and the utc (gmt)
 * @property {GUID} msid
 * @property {string} skin - skin name
 * @property {boolean} ad_state - true if campaign was sent with EM Ad
 * @property {string} template_id - id of the template
 * @return {LogObject<shoutoutSendPageMessageSentParams>} LogObject<shoutoutSendPageMessageSentParams>
 */
export function shoutoutSendPageMessageSent(params) {
    return { evid: 50, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWellDoneShareButton' event (evid: 51)
 *
 * Event description: shoutout well done -> share button.
 *
 * @param {shoutoutWellDoneShareButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {boolean} is_resend - was action performed in resend to non-openers flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<shoutoutWellDoneShareButtonParams>} LogObject<shoutoutWellDoneShareButtonParams>
 */
export function shoutoutWellDoneShareButton(params) {
    return { evid: 51, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWellDoneClickOnLink' event (evid: 52)
 *
 * Event description: shoutout well done -> click on link.
 *
 * @param {shoutoutWellDoneClickOnLinkParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutWellDoneClickOnLinkParams>} LogObject<shoutoutWellDoneClickOnLinkParams>
 */
export function shoutoutWellDoneClickOnLink(params) {
    return { evid: 52, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutPreviewBackClick' event (evid: 55)
 *
 * Event description: PREVIEW_BACK_CLICK
 *
 * @param {shoutoutPreviewBackClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutPreviewBackClickParams>} LogObject<shoutoutPreviewBackClickParams>
 */
export function shoutoutPreviewBackClick(params) {
    return { evid: 55, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeDoneClick' event (evid: 56)
 *
 * Event description: COMPOSER_DONE_CLICK
 *
 * @param {shoutoutComposeDoneClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeDoneClickParams>} LogObject<shoutoutComposeDoneClickParams>
 */
export function shoutoutComposeDoneClick(params) {
    return { evid: 56, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutComposeCancelClick' event (evid: 57)
 *
 * Event description: COMPOSER_CANCEL_CLICK
 *
 * @param {shoutoutComposeCancelClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package - vendor product id
 * @property {string} context - application context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package group (Free/Basic/Pro)
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutComposeCancelClickParams>} LogObject<shoutoutComposeCancelClickParams>
 */
export function shoutoutComposeCancelClick(params) {
    return { evid: 57, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesPageView' event (evid: 58)
 *
 * Event description: templates page view
 *
 * @param {shoutoutTemplatesPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - na
 * @property {string} origin - new so/templates
 * @property {string} templatesList - templates list loaded to user - for  impressions
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutTemplatesPageViewParams>} LogObject<shoutoutTemplatesPageViewParams>
 */
export function shoutoutTemplatesPageView(params) {
    return { evid: 58, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesMakeItYoursClick' event (evid: 59)
 *
 * Event description: templates - choosing a template
 *
 * @param {shoutoutTemplatesMakeItYoursClickParams} params - The parameters for this event
 * @property {number} template_index - start from 0 - more per category
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id
 * @property {string} template_list_name - list name(BO) || top/bottom
 * @property {string} template_name - na
 * @property {string} template_type - dynamic/static
 * @property {string} context
 * @property {GUID} uuid
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - na
 * @property {string} origin - dashboard/template page
 * @property {GUID} msid
 * @property {string} template_id - template_id
 * @return {LogObject<shoutoutTemplatesMakeItYoursClickParams>} LogObject<shoutoutTemplatesMakeItYoursClickParams>
 */
export function shoutoutTemplatesMakeItYoursClick(params) {
    return { evid: 59, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutTemplatesPreviewClick' event (evid: 63)
 *
 * Event description: templates - previewing a template
 *
 * @param {shoutoutTemplatesPreviewClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} template_name - na
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - na
 * @property {string} origin - dashboard/template page
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutTemplatesPreviewClickParams>} LogObject<shoutoutTemplatesPreviewClickParams>
 */
export function shoutoutTemplatesPreviewClick(params) {
    return { evid: 63, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'emMessageCtaClick' event (evid: 64)
 *
 * Event description: Action made by the user in EM - Message Shown
 *
 * @param {emMessageCtaClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} cta_name - name of the message/banner/CTA/pop-up, same as 36:40
 * @property {GUID} msid - msid
 * @property {string} action - action value
 * @property {string} metadata - field for custom values in the event: Map[string:string]
 * @property {string} value - value of the action if needed
 * @return {LogObject<emMessageCtaClickParams>} LogObject<emMessageCtaClickParams>
 */
export function emMessageCtaClick(params) {
    return { evid: 64, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarContactsClick' event (evid: 65)
 *
 * Event description: Click on contacts
 *
 * @param {shoutoutSidebarContactsClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarContactsClickParams>} LogObject<shoutoutSidebarContactsClickParams>
 */
export function shoutoutSidebarContactsClick(params) {
    return { evid: 65, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutMyShoutoutsPageView' event (evid: 66)
 *
 * Event description: Click on contacts
 *
 * @param {shoutoutMyShoutoutsPageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - na
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutMyShoutoutsPageViewParams>} LogObject<shoutoutMyShoutoutsPageViewParams>
 */
export function shoutoutMyShoutoutsPageView(params) {
    return { evid: 66, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarSubscribeFormClick' event (evid: 67)
 *
 * Event description: Click on Subscribe Form
 *
 * @param {shoutoutSidebarSubscribeFormClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarSubscribeFormClickParams>} LogObject<shoutoutSidebarSubscribeFormClickParams>
 */
export function shoutoutSidebarSubscribeFormClick(params) {
    return { evid: 67, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutGetSubscribersAddNowClick' event (evid: 68)
 *
 * Event description: Click on Subscribe Form
 *
 * @param {shoutoutGetSubscribersAddNowClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutGetSubscribersAddNowClickParams>} LogObject<shoutoutGetSubscribersAddNowClickParams>
 */
export function shoutoutGetSubscribersAddNowClick(params) {
    return { evid: 68, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardShareButton' event (evid: 69)
 *
 * Event description: event for so db share button , has been ignored till now
 *
 * @param {shoutoutDashboardShareButtonParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} value - na
 * @return {LogObject<shoutoutDashboardShareButtonParams>} LogObject<shoutoutDashboardShareButtonParams>
 */
export function shoutoutDashboardShareButton(params) {
    return { evid: 69, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'reuseTemplateModalShown' event (evid: 70)
 *
 * Event description: Modal for reusing templates shown/viewed
 *
 * @param {reuseTemplateModalShownParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<reuseTemplateModalShownParams>} LogObject<reuseTemplateModalShownParams>
 */
export function reuseTemplateModalShown(params) {
    return { evid: 70, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'reuseTemplateModalAction' event (evid: 71)
 *
 * Event description: Any action done in the Reuse Template Modal
 *
 * @param {reuseTemplateModalActionParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} tab_name - automated_emails/email_campaigns
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {string} action - name of the action made
 * @property {string} action_value - action_value
 * @property {string} old_message_id - old message id
 * @property {string} new_message_id - new message id
 * @return {LogObject<reuseTemplateModalActionParams>} LogObject<reuseTemplateModalActionParams>
 */
export function reuseTemplateModalAction(params) {
    return { evid: 71, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutOpen' event (evid: 76)
 *
 * Event description: shoutout -> open
 *
 * @param {shoutoutOpenParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - referral_info
 * @property {GUID} page_id - na
 * @property {boolean} is_first - is first time user got to shoutout
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutOpenParams>} LogObject<shoutoutOpenParams>
 */
export function shoutoutOpen(params) {
    return { evid: 76, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardNewShoutoutClicked' event (evid: 77)
 *
 * Event description: new shoutout clicked
 *
 * @param {shoutoutDashboardNewShoutoutClickedParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - ts for SO in Editor
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} viewmode - viewmode for SO in Editor
 * @property {string} origin - origin
 * @property {string} editor_working_mode - (esi, ts, viewmode) default editor field
 * @property {GUID} esi - esi for SO in Editor
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardNewShoutoutClickedParams>} LogObject<shoutoutDashboardNewShoutoutClickedParams>
 */
export function shoutoutDashboardNewShoutoutClicked(params) {
    return { evid: 77, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardShoutoutReuse' event (evid: 78)
 *
 * Event description: new shoutout clicked
 *
 * @param {shoutoutDashboardShoutoutReuseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} location - campaign_banner/my_campaigns_list
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardShoutoutReuseParams>} LogObject<shoutoutDashboardShoutoutReuseParams>
 */
export function shoutoutDashboardShoutoutReuse(params) {
    return { evid: 78, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutDashboardShoutoutDraftEdit' event (evid: 79)
 *
 * Event description: shoutout draft edit
 *
 * @param {shoutoutDashboardShoutoutDraftEditParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} message_id - message_id
 * @property {string} messages_type - draft/published
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutDashboardShoutoutDraftEditParams>} LogObject<shoutoutDashboardShoutoutDraftEditParams>
 */
export function shoutoutDashboardShoutoutDraftEdit(params) {
    return { evid: 79, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWidgetListView' event (evid: 80)
 *
 * Event description: shoutout widget-> list view.
 *
 * @param {shoutoutWidgetListViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} total_views - total_views
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {number} total - total
 * @property {number} total_sent - total_sent
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutWidgetListViewParams>} LogObject<shoutoutWidgetListViewParams>
 */
export function shoutoutWidgetListView(params) {
    return { evid: 80, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWidgetBlankView' event (evid: 81)
 *
 * Event description: shoutout widget-> blank view.
 *
 * @param {shoutoutWidgetBlankViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutWidgetBlankViewParams>} LogObject<shoutoutWidgetBlankViewParams>
 */
export function shoutoutWidgetBlankView(params) {
    return { evid: 81, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWidgetErrorView' event (evid: 82)
 *
 * Event description: shoutout widget-> error view.
 *
 * @param {shoutoutWidgetErrorViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @property {number} error_code - errc
 * @return {LogObject<shoutoutWidgetErrorViewParams>} LogObject<shoutoutWidgetErrorViewParams>
 */
export function shoutoutWidgetErrorView(params) {
    return { evid: 82, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutWidgetNewShoutoutClick' event (evid: 83)
 *
 * Event description: shoutout widget-> new shoutout click.
 *
 * @param {shoutoutWidgetNewShoutoutClickParams} params - The parameters for this event
 * @property {string} state - blank/active
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} origin - blank/active
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutWidgetNewShoutoutClickParams>} LogObject<shoutoutWidgetNewShoutoutClickParams>
 */
export function shoutoutWidgetNewShoutoutClick(params) {
    return { evid: 83, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutVideoVideoPlayClick' event (evid: 87)
 *
 * Event description: When user clicking 'play' button on video widget
 *
 * @param {shoutoutVideoVideoPlayClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutVideoVideoPlayClickParams>} LogObject<shoutoutVideoVideoPlayClickParams>
 */
export function shoutoutVideoVideoPlayClick(params) {
    return { evid: 87, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutVideoVideoCloseClick' event (evid: 88)
 *
 * Event description: When user clicking 'X' or CTA button on video widget
 *
 * @param {shoutoutVideoVideoCloseClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} click_location - either its on 'X' or CTA button
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutVideoVideoCloseClickParams>} LogObject<shoutoutVideoVideoCloseClickParams>
 */
export function shoutoutVideoVideoCloseClick(params) {
    return { evid: 88, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEditorPanelOpen' event (evid: 89)
 *
 * Event description: shoutout editor panel-> open
 *
 * @param {shoutoutEditorPanelOpenParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} notification - gsNotTouched/gsNotIntalled/none
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - timespan from session start
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - view_mode
 * @property {boolean} is_first - is first time user opened the panel
 * @property {string} editor_working_mode - editor_working_mode
 * @property {string} type - GetSubscribers/Email
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEditorPanelOpenParams>} LogObject<shoutoutEditorPanelOpenParams>
 */
export function shoutoutEditorPanelOpen(params) {
    return { evid: 89, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEditorPanelClose' event (evid: 90)
 *
 * Event description: shoutout editor panel-> close
 *
 * @param {shoutoutEditorPanelCloseParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {GUID} site_id - site_id for SO in Editor
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - ts for SO in Editor
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - ts for SO in Editor
 * @property {boolean} is_first - is first time user used the panel
 * @property {GUID} esi - esi for SO in Editor
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEditorPanelCloseParams>} LogObject<shoutoutEditorPanelCloseParams>
 */
export function shoutoutEditorPanelClose(params) {
    return { evid: 90, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutEditorPanelCloseTemplateFrame' event (evid: 91)
 *
 * Event description: shoutout editor panel-> close template frame
 *
 * @param {shoutoutEditorPanelCloseTemplateFrameParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {number} ts - ts for SO in Editor
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} referral_info - shoutout editor panel
 * @property {string} viewmode - viewmode for SO in Editor
 * @property {boolean} is_first - is first time user used the panel
 * @property {GUID} esi - esi for SO in Editor
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutEditorPanelCloseTemplateFrameParams>} LogObject<shoutoutEditorPanelCloseTemplateFrameParams>
 */
export function shoutoutEditorPanelCloseTemplateFrame(params) {
    return { evid: 91, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shotuoutComplianceReasonToolTip' event (evid: 92)
 *
 * Event description: in the compliance page - over on info icon
 *
 * @param {shotuoutComplianceReasonToolTipParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id
 * @property {string} context
 * @property {GUID} uuid
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} reason_tooltip - which of the info: Spam_complaints / spam_traps / bounces / low_engagement
 * @property {string} reason - Spam_complaints / spam_traps / bounces / low_engagement / vetting - from server
 * @property {string} page_name - from which page of the compliance
 * @property {GUID} msid - msid
 * @property {string} compliance_status - Warned / suspended / banned (from server)
 * @return {LogObject<shotuoutComplianceReasonToolTipParams>} LogObject<shotuoutComplianceReasonToolTipParams>
 */
export function shotuoutComplianceReasonToolTip(params) {
    return { evid: 92, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shotuoutCompliancePageView' event (evid: 93)
 *
 * Event description: page view loaded for user
 *
 * @param {shotuoutCompliancePageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id
 * @property {string} context
 * @property {GUID} uuid
 * @property {string} package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} reason - coma separated reasons
 * @property {string} page_name - from which page of the compliance: Warning / Get_in_touch / message_submitted / suspended / questionnaire / questionnaire_submitted / case_process_qustionnaire / banned / case_process_banned
 * @property {GUID} msid - msid
 * @property {string} compliance_status - Warned / suspended / banned (from server)
 * @return {LogObject<shotuoutCompliancePageViewParams>} LogObject<shotuoutCompliancePageViewParams>
 */
export function shotuoutCompliancePageView(params) {
    return { evid: 93, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutNotificationPresentNotificationDialog' event (evid: 94)
 *
 * Event description: present notification dialog
 *
 * @param {shoutoutNotificationPresentNotificationDialogParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutNotificationPresentNotificationDialogParams>} LogObject<shoutoutNotificationPresentNotificationDialogParams>
 */
export function shoutoutNotificationPresentNotificationDialog(params) {
    return { evid: 94, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutNotificationAllowNotification' event (evid: 95)
 *
 * Event description: present notification dialog
 *
 * @param {shoutoutNotificationAllowNotificationParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {boolean} allowNotification - yes/no
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutNotificationAllowNotificationParams>} LogObject<shoutoutNotificationAllowNotificationParams>
 */
export function shoutoutNotificationAllowNotification(params) {
    return { evid: 95, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'completePageView' event (evid: 97)
 *
 * Event description: user views the complete page
 *
 * @param {completePageViewParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} page_id - the message id of the shoutOut
 * @property {GUID} msid - msid
 * @return {LogObject<completePageViewParams>} LogObject<completePageViewParams>
 */
export function completePageView(params) {
    return { evid: 97, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'headerNextClick' event (evid: 98)
 *
 * Event description: Header next click
 *
 * @param {headerNextClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {number} count - count
 * @property {string} package_id - package_name
 * @property {string} template_name - template_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {string} current - currentPage
 * @property {GUID} msid - msid
 * @return {LogObject<headerNextClickParams>} LogObject<headerNextClickParams>
 */
export function headerNextClick(params) {
    return { evid: 98, src: 36, endpoint: 'shout', params: params };
}
/**
 * A function to create a log object for the 'shoutoutSidebarTemplatesClick' event (evid: 99)
 *
 * Event description: Click on contacts
 *
 * @param {shoutoutSidebarTemplatesClickParams} params - The parameters for this event
 * @property {boolean} is_advanced_flow - is_advanced_flow
 * @property {string} package_id - package_name
 * @property {string} context - context
 * @property {GUID} uuid - uuid
 * @property {string} package_group - package_group
 * @property {string} ml_translation_language - ml_translation_language
 * @property {GUID} msid - msid
 * @return {LogObject<shoutoutSidebarTemplatesClickParams>} LogObject<shoutoutSidebarTemplatesClickParams>
 */
export function shoutoutSidebarTemplatesClick(params) {
    return { evid: 99, src: 36, endpoint: 'shout', params: params };
}
//# sourceMappingURL=index.js.map